// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-09-23T19:56:39.206Z
// Property: Creekside Village (ID: 6767906449166889)
// Collections: 24 amenities, 4 floorplans (live), 35 photos, 42 POIs, 3 reviews, 5 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162446",
  "multihub_property_id": "6767906449166889",
  "property_external_id": "495796",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/creekside-village-eugene-or/87w2860/",
  "property_google_business_url": "https://www.google.com/maps/place/Creekside+Village+Apartments/data=!4m2!3m1!1s0x0:0x55d287010e4cd81d?sa=X&ved=2ahUKEwimg-TziLySAxUfmbAFHTKGMr0Q_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "40343719840",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "495796 p0505464",
  "property_status": null,
  "property_slug": "creekside-village",
  "property_name": "Creekside Village",
  "property_website_url": "http://www.eugeneoregonapartments.com/",
  "property_domain": "https://www.eugeneoregonapartments.com/",
  "property_address": "4675 Goodpasture Loop",
  "property_full_address": "4675 Goodpasture Loop, Eugene, OR 97401",
  "property_address_1": "4675 Goodpasture Loop",
  "property_address_2": null,
  "property_address_city": "Eugene",
  "property_address_state": "OR",
  "property_address_zip_full": null,
  "property_address_zip": "97401",
  "property_address_country": "US",
  "property_address_county": "Lane County",
  "property_neighborhood_address": "Cal Young",
  "property_address_latitude": "44.0889622",
  "property_address_longitude": "-123.1066312",
  "property_email": "creeksidevillage@ctlmanagement.com",
  "property_phone": "(458) 254-5529",
  "property_call_tracking_phone": null,
  "property_company_name": "CTL Management ",
  "property_company_url": "https://ctlmanagement.randallgroup.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Creekside Village in Eugene, OR, where comfort meets style. Choose from spacious one, two, or three-bedroom apartments featuring vaulted ceilings, walk-in closets, and private patios. Enjoy amenities like a refreshing pool, fitness center, and dog park. Elevate your living experience—find your new home today!",
  "property_long_description": "Welcome to Creekside Village, your ideal apartment community nestled in the heart of Eugene, OR! Our thoughtfully designed floor plans offer a variety of options to suit your lifestyle, including spacious one, two, and three-bedroom apartments. With amenities that elevate your living experience, Creekside Village is more than just a place to live—it's a place to thrive.\n\nDive into relaxation in our sparkling pool, or break a sweat at our fully equipped fitness center; we have everything you need to stay active and unwind. Families will appreciate our playground, while our welcoming clubhouse serves as a perfect gathering spot for friends and neighbors. For those who work from home or need to catch up on business, our dedicated business center and online services make your daily tasks a breeze.\n\nPet lovers rejoice! Our dog park offers a safe space for your furry friends to frolic and play. Each apartment features desirable amenities, including in-unit washers and dryers, walk-in closets, and private patios or balconies—perfect for soaking in the serene views of our community. Enjoy smoke-free living with additional perks such as vaulted ceilings and high-speed internet access.\n\nAt Creekside Village, you’ll find a vibrant community that prioritizes comfort and convenience. Discover the perfect blend of modern living and natural beauty. **Find your new home today—browse our availability or schedule a tour to visit our community!** Experience the lifestyle you've always wanted at Creekside Village!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d2b51-0c6e-76fb-a91a-cc6efc05a88e.webp",
  "property_featured_image_media": {
    "alt_text": "Apartment complex courtyard with a rock waterfall and garden landscaping.",
    "public_id": "019d2b51-0c6e-76fb-a91a-cc6efc05a88e",
    "storage_key": "property/6767906449166889/019d2b51-0c6e-76fb-a91a-cc6efc05a88e.webp",
    "width": 2007,
    "height": 937
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "185",
  "property_year_built": "1996",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.5945945945946",
  "property_admin_fee": null,
  "property_application_fee": "10",
  "property_fees_deposit_info": "Deposit: $400",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "0",
  "property_pet_deposit": "400",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "25",
  "property_pet_restrictions": " ",
  "property_pet_policy_description": "Only indoor adult cats and indoor adult dogs are allowed; adult is defined as at least one year old. Deposit and monthly pet rent are per pet.  Small caged animals are allowed without a deposit and pet rent. Small caged animals that are allowed are common domesticated household birds, hamsters, gerbils, rabbits, guinea pigs, chinchillas and aquarium/terrarium animals including fish, hermit crabs, turtles, frogs, and small lizards.  Animals such as birds of prey, iguanas, ferrets, snakes, rats, mice, insects, arachnids (including spiders and scorpions), livestock, or any other exotic animals are not allowed. No animals are allowed that are venomous, biting, stinging, constricting, or pose a threat of infestation. Small animals are limited to a maximum of two, with the exception of fish which should be kept to a reasonable amount, and must be kept confined in appropriate and reasonably sized cages or aquariums/terrariums.  Resident shall not have more than three aquariums and the total combined capacity between all aquariums shall not exceed 40 gallons.",
  "property_petpolicy_info": "Max 2 Allowed | Max weight 25 lb each\nRent $25 | Deposit $400",
  "property_online_leasing_url": "https://eugeneoregonapts.securecafe.com/onlineleasing/creekside-village-3/guestlogin",
  "property_resident_portal_url": "https://eugeneoregonapts.securecafenet.com/residentservices/creekside-village-3/userlogin",
  "property_apply_now_url": "https://eugeneoregonapartments.securecafe.com/onlineleasing/creekside-village-3/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d73cc-9914-7179-910d-4edd5096bba9.webp",
  "property_primary_logo_media": {
    "alt_text": "Creekside Village Apartments logo.",
    "public_id": "019d73cc-9914-7179-910d-4edd5096bba9",
    "storage_key": "property/6767906449166889/019d73cc-9914-7179-910d-4edd5096bba9.webp",
    "width": 844,
    "height": 160
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d73cc-98fc-7015-a2df-75516917a10f.webp",
  "property_secondary_logo_media": {
    "alt_text": "Creekside Village Apartments logo",
    "public_id": "019d73cc-98fc-7015-a2df-75516917a10f",
    "storage_key": "property/6767906449166889/019d73cc-98fc-7015-a2df-75516917a10f.webp",
    "width": 844,
    "height": 160
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019de0b2-a57e-7265-88d3-17ec94efc42c.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Abstract graphic with horizontal white band on dark background",
    "public_id": "019de0b2-a57e-7265-88d3-17ec94efc42c",
    "storage_key": "property/6767906449166889/019de0b2-a57e-7265-88d3-17ec94efc42c.webp",
    "width": 844,
    "height": 160
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019de0b2-9883-765e-a394-c6072aabee67.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Black horizontal bar",
    "public_id": "019de0b2-9883-765e-a394-c6072aabee67",
    "storage_key": "property/6767906449166889/019de0b2-9883-765e-a394-c6072aabee67.webp",
    "width": 844,
    "height": 160
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
  "property_company_logo_media": {
    "alt_text": "CTL Management logo",
    "public_id": "019d9c74-7219-719e-b7ea-ff6185375ae5",
    "storage_key": "company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
    "width": 201,
    "height": 60
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#14473D",
  "property_secondary_color": "#9EBAC2",
  "property_font_color": "#14473D",
  "property_color_4": "#F27859",
  "property_color_3": "#4F756E",
  "property_color_5": "#FAAD45",
  "property_color_6": "#FCF5F0",
  "property_color_7": "#CFDBE0",
  "property_color_8": "#FCE3BD",
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "719 - 1105",
  "property_sqft_min": "719",
  "property_sqft_max": "1105",
  "property_price_range": "1495 - 3425",
  "property_price_min": "1495",
  "property_price_max": "3425",
  "property_available_units": 9,
  "property_facebook_url": "https://www.facebook.com/creeksidevillage1",
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJp3HxIXbiwFQRHdhMDgGH0lU",
  "property_youtube_url": "https://www.youtube.com/watch?t=411&v=IDbw0V4V5ew",
  "property_yelp_url": "https://www.yelp.com/search?cflt=apartments&find_near=heron-meadows-eugene",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Creekside Village",
  "property_home_romance_title": "Embrace Life and Love in Your New Apartment Community",
  "property_home_amenities_blurb": "Welcome to Creekside Village in Eugene, OR, where comfort meets convenience. Choose from spacious one, two, or three-bedroom floor plans designed for modern living. Dive into a refreshing pool, unwind at the spa, or enjoy online services—all within a vibrant community that feels like home. Your ideal lifestyle awaits!",
  "property_home_floorplans_blurb": "Welcome to Creekside Village in vibrant Eugene, OR, where contemporary living meets natural beauty. With a variety of thoughtfully designed floor plans, our community invites you to envision your ideal home. Browse our available apartment homes today and step into a space tailored for your unique lifestyle.",
  "property_home_gallery_blurb": "Welcome to Creekside Village, where your ideal home awaits in the heart of Eugene, OR. Choose from spacious one, two, or three-bedroom floor plans, complemented by amenities like a refreshing pool, state-of-the-art fitness center, and a relaxing spa. Picture yourself living here, surrounded by comfort and convenience.",
  "property_home_neighborhood_blurb": "Welcome to Creekside Village in Eugene, OR, where vibrant living meets local charm. Nestled near the University of Oregon, enjoy easy access to the Eugene Public Library and scenic parks like Alton Baker Park. Experience a community that blends comfort with culture—your ideal home awaits among Eugene's best-kept secrets!",
  "property_home_reviews_blurb": "Nestled in the heart of Eugene, Creekside Village offers residents an unparalleled living experience. With one reviewer praising, “The peaceful ambiance and friendly neighbors make it feel like home,” our community thrives on connection and comfort. See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "Nestled in the heart of Eugene, Creekside Village invites you to embrace a lifestyle enriched by vibrant local culture. With the University of Oregon, Knight Library, and the serene Alton Baker Park just moments away, your new home offers endless opportunities for exploration and connection. See what's around our community and discover local favorites!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Creekside Village in Eugene, OR, your dream home awaits! Choose from one, two, or three-bedroom floor plans designed for comfort and style. Dive into luxury with our sparkling pool, unwind at the spa, or let your furry friend roam in the dog park. Experience community living like never before!",
  "property_applynow_blurb": "At Creekside Village in Eugene, OR, find your perfect apartment—be it a cozy one-bedroom or a spacious three-bedroom. Enjoy resort-style amenities, from a sparkling pool and fitness center to a relaxing spa and vibrant dog park. Ready to elevate your lifestyle? Lease online today and secure your new home!",
  "property_contactus_blurb": "At Creekside Village in Eugene, OR, find your perfect fit among our thoughtfully designed one, two, and three-bedroom floor plans. With a blend of comfort and modern living, there's a space for everyone. Have questions? Contact our leasing team today to learn more about your future home!",
  "property_faqs_blurb": "At Creekside Village in Eugene, OR, we cater to every lifestyle with our thoughtfully designed one, two, and three-bedroom floor plans. Have questions? Unravel the details of our community and amenities by visiting our FAQs page, where you'll find clear answers to enhance your living experience.",
  "property_floorplans_blurb": "At Creekside Village in Eugene, OR, your ideal home awaits! Choose from spacious one, two, or three-bedroom floor plans designed for comfort and style. Each layout enhances your living experience, nestled in a serene community. Browse our available apartment homes and find the perfect fit for your lifestyle today!",
  "property_gallery_blurb": "At Creekside Village in Eugene, OR, your perfect home awaits. Whether you choose a cozy one-bedroom or a spacious three-bedroom, enjoy upscale amenities like a refreshing pool, state-of-the-art fitness center, and inviting clubhouse. Picture yourself living here and embracing a lifestyle filled with comfort and community!",
  "property_interactivemap_blurb": "At Creekside Village in Eugene, OR, your perfect home awaits. Choose from spacious one, two, or three-bedroom floor plans and indulge in top-notch amenities like a sparkling pool, fitness center, and dog park. Use our interactive community map to find your dream apartment today! Your ideal lifestyle starts here.",
  "property_pets_blurb": "At Creekside Village in Eugene, OR, your furry friends are part of the family! Our pet-friendly community welcomes indoor cats and dogs (under 25 lbs) to enjoy life together. With cozy spaces and an inviting atmosphere, you’ll find the perfect home for both you and your pet companions.",
  "property_referafriend_blurb": "At Creekside Village in Eugene, OR, we celebrate community connections! With versatile one, two, and three-bedroom floor plans, there’s a perfect space for everyone. Love where you live? Share the joy—refer a friend to join our vibrant neighborhood and enjoy life together in comfort and style!",
  "property_residentaccess_blurb": "Welcome to Creekside Village in beautiful Eugene, OR! Utilize our convenient resident portal to manage your living experience effortlessly. Whether you're in a cozy one-bedroom or a spacious three-bedroom, accessing rent payments and maintenance requests has never been easier. Dive into a community designed for your comfort and convenience!",
  "property_reviews_blurb": "At Creekside Village in Eugene, OR, residents cherish the vibrant community spirit and stunning natural surroundings. One resident notes, “The peaceful ambiance and friendly neighbors make it truly feel like home.” See what our residents have to say about living here, and feel the warmth that awaits you!",
  "property_created_at": "1762784794378",
  "property_scheduletour_blurb": "At Creekside Village in Eugene, OR, a variety of stylish floor plans await—choose from cozy one-bedroom retreats to spacious three-bedroom homes. Each layout is designed for comfort and convenience. Curious about our vibrant community? Schedule a tour today and hear firsthand from our satisfied residents!",
  "property_thankyou_blurb": "Thank you for reaching out to Creekside Village in Eugene, OR! Whether you seek a cozy one-bedroom oasis or a spacious three-bedroom retreat, our diverse floor plans are designed to meet your lifestyle needs. Our team will connect with you soon to help find your perfect home.",
  "property_virtualtours_blurb": "Welcome to Creekside Village in Eugene, OR, where comfort meets modern living. Our thoughtfully designed one, two, and three-bedroom floor plans accommodate every lifestyle. Ready to envision your new home? Take a virtual tour and experience the charm of our vibrant community and stunning apartments for rent!",
  "property_copyright": "2025 All Rights Reserved. Creekside Village",
  "property_seo_title_home": "Creekside Village |  Apartments in Eugene, OR",
  "property_seo_description_home": "Experience comfort at Creekside Village in Eugene, OR. Choose from spacious one to three-bedroom layouts with top-notch amenities. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Eugene, OR Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Creekside Village in Eugene, OR. Choose from cozy one, two, or three-bedroom layouts that suit your lifestyle. Browse now!",
  "property_seo_title_amenities": "Amenities | Eugene, OR Apartments for Rent",
  "property_seo_description_amenities": "Discover home at Creekside Village, Eugene, OR. Enjoy modern amenities: pool, fitness center, and pet-friendly spaces. Your perfect lifestyle awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Eugene, OR",
  "property_seo_description_gallery": "Imagine your dream life at Creekside Village, Eugene! Enjoy spacious layouts, modern amenities, a pool, fitness center, and a dog park!",
  "property_seo_title_virtualtours": "Virtual Tours | Creekside Village Apartments",
  "property_seo_description_virtualtours": "Experience Creekside Village in Eugene, OR! Take a virtual tour of our stunning one, two, and three-bedroom apartments, where comfort meets style. Come see!",
  "property_seo_title_interactivemap": "Interactive Map | Creekside Village Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Creekside Village in Eugene, OR. Use our interactive map to explore one to three-bedroom apartments with fantastic amenities!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Eugene, OR",
  "property_seo_description_neighborhood": "Experience the charm of Creekside Village in Eugene, OR. Uncover local favorites, parks, and vibrant hotspots—all just steps from your new home!",
  "property_seo_title_contact": "Contact Us | Creekside Village",
  "property_seo_description_contact": "Reach out to our leasing team at Creekside Village in Eugene, OR. Inquire about our spacious one, two, and three-bedroom floor plans that fit your lifestyle!",
  "property_seo_title_faqs": "FAQs | Apartments in Eugene, OR",
  "property_seo_description_faqs": "Find the answers you need about Creekside Village in Eugene, OR! From floor plans to amenities, our FAQs cover everything for your perfect home.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Eugene, OR",
  "property_seo_description_reviews": "Discover Creekside Village in Eugene, OR! Enjoy spacious homes, great amenities, and a vibrant community. Read resident reviews today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Eugene, OR",
  "property_seo_description_applynow": "Find your perfect home at Creekside Village in Eugene! Choose from spacious one-to-three bedroom apartments with top amenities. Apply online today!",
  "property_seo_title_residentaccess": "Resident Access | Creekside Village",
  "property_seo_description_residentaccess": "Access Creekside Village's resident portal for easy rent payments, maintenance requests, and community updates in sunny Eugene, OR!",
  "property_seo_title_referafriend": "Refer A Friend | Creekside Village",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to Creekside Village in Eugene, OR, and enjoy a vibrant community together. Join us today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Creekside Village",
  "property_seo_description_scheduletour": "Experience life at Creekside Village in Eugene, OR. Enjoy beautiful surroundings and modern amenities. Schedule your tour today and envision your new home!",
  "property_seo_title_privacy": "Privacy Policy | Creekside Village",
  "property_seo_description_privacy": "Your privacy matters at Creekside Village. Learn how we protect your data while you enjoy comfortable living in Eugene, OR. View our privacy policy now!",
  "property_seo_title_accessibility": "Website Accessibility | Creekside Village",
  "property_seo_description_accessibility": "At Creekside Village in Eugene, OR, we prioritize digital accessibility, ensuring everyone can enjoy our community. Embrace inclusivity in every click!",
  "property_seo_title_sitemap": "Sitemap | Creekside Village",
  "property_seo_description_sitemap": "Navigate your way through Creekside Village in Eugene, OR! Our sitemap guides you to every corner of our thriving community. Map your future today!",
  "property_seo_title_thankyou": "Thank You | Creekside Village",
  "property_seo_description_thankyou": "Thank you for reaching out to Creekside Village in Eugene, OR! A team member will connect with you soon to help you find your perfect home.",
  "property_seo_title_pets": "Pet Policy | Apartments in Eugene, OR",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1778874762531",
  "amenities": [
    {
      "id": "ec_4934cd0b47f953791d825892",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "yardi",
      "external_id": "80428787",
      "title": "Clubhouse with Complimentary Wi-Fi",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d496c-dee4-779b-b390-57b744b69297.webp",
      "amenity_image_media": {
        "alt_text": "Living room with a stone fireplace, two accent chairs, and a coffee table.",
        "public_id": "019d496c-dee4-779b-b390-57b744b69297",
        "storage_key": "property/6767906449166889/019d496c-dee4-779b-b390-57b744b69297.webp",
        "width": 2048,
        "height": 1463
      },
      "amenity_image_alt_text": "Community Room With Fireplace at Creekside Village, Eugene, 97401",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_be01184de1a8b0e271c35f1d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "yardi",
      "external_id": "86391131",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d496d-067f-704b-b6ff-48124d4bb3c1.webp",
      "amenity_image_media": {
        "alt_text": "Business center with computers, printer, and seating area.",
        "public_id": "019d496d-067f-704b-b6ff-48124d4bb3c1",
        "storage_key": "property/6767906449166889/019d496d-067f-704b-b6ff-48124d4bb3c1.webp",
        "width": 2048,
        "height": 1463
      },
      "amenity_image_alt_text": "Business Center at Creekside Village, Eugene, OR, 97401",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1bba3c805fbdcdc7247d78a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "yardi",
      "external_id": "80428784",
      "title": "24-Hour Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d496d-0d79-733b-9971-eda2329e66c0.webp",
      "amenity_image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, and weight machines.",
        "public_id": "019d496d-0d79-733b-9971-eda2329e66c0",
        "storage_key": "property/6767906449166889/019d496d-0d79-733b-9971-eda2329e66c0.webp",
        "width": 2048,
        "height": 1463
      },
      "amenity_image_alt_text": "24 Hour Fitness Center at Creekside Village, Eugene, Oregon",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fff79069d625db7aefb5233a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "yardi",
      "external_id": "80428790",
      "title": "Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d3346-fd55-711c-8846-e43692ed3ad3.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at the apartment complex.",
        "public_id": "019d3346-fd55-711c-8846-e43692ed3ad3",
        "storage_key": "property/6767906449166889/019d3346-fd55-711c-8846-e43692ed3ad3.webp",
        "width": 2048,
        "height": 1463
      },
      "amenity_image_alt_text": "Blue Cool Pool at Creekside Village, Eugene, 97401,Poolside Lounge Chairs at Creekside Village, Eugene, 97401,Pool With Lounge Chairs at Creekside Village, Eugene, Oregon,outdoor swimming pool and pool deck with furniture at Creekside Village, Eugene, OR",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f76f370bb18d4d5fd82180d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "yardi",
      "external_id": "80428797",
      "title": "Spa",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d42a4-6222-748c-91a5-d28c1ecbac9d.webp",
      "amenity_image_media": {
        "alt_text": "Indoor jacuzzi with teal water and wood paneling.",
        "public_id": "019d42a4-6222-748c-91a5-d28c1ecbac9d",
        "storage_key": "property/6767906449166889/019d42a4-6222-748c-91a5-d28c1ecbac9d.webp",
        "width": 1024,
        "height": 732
      },
      "amenity_image_alt_text": "Indoor Spa at Creekside Village, Oregon, 97401",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1154022fe3f8aa9d8f7bc604",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "yardi",
      "external_id": "80428786",
      "title": "Carports",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d496d-32e1-724a-b224-d7b7406c0cfd.webp",
      "amenity_image_media": {
        "alt_text": "Carports and bike racks outside apartment buildings.",
        "public_id": "019d496d-32e1-724a-b224-d7b7406c0cfd",
        "storage_key": "property/6767906449166889/019d496d-32e1-724a-b224-d7b7406c0cfd.webp",
        "width": 2048,
        "height": 1367
      },
      "amenity_image_alt_text": "Street Parking at Creekside Village, Eugene, OR, 97401",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0e5e6108d3ad6b4d08e1cda4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "yardi",
      "external_id": "80428791",
      "title": "Garages",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d496d-492e-733c-bba1-c394dfd4e6df.webp",
      "amenity_image_media": {
        "alt_text": "A row of garages with white doors and blue siding.",
        "public_id": "019d496d-492e-733c-bba1-c394dfd4e6df",
        "storage_key": "property/6767906449166889/019d496d-492e-733c-bba1-c394dfd4e6df.webp",
        "width": 2048,
        "height": 1498
      },
      "amenity_image_alt_text": "Universally Attached Garages at Creekside Village, Eugene, 97401",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ca16947153fb63f85d2142a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "yardi",
      "external_id": "86392824",
      "title": "Clubhouse Coffee Bar",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d496c-dc91-7316-b724-aa307158f999.webp",
      "amenity_image_media": {
        "alt_text": "Creekside Cafe with complimentary coffee, hot cocoa, apple cider, and tea.",
        "public_id": "019d496c-dc91-7316-b724-aa307158f999",
        "storage_key": "property/6767906449166889/019d496c-dc91-7316-b724-aa307158f999.webp",
        "width": 2048,
        "height": 1463
      },
      "amenity_image_alt_text": "Clubhouse Lobby at Creekside Village, Eugene, 97401",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7601c0c8260a49b82663067f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "yardi",
      "external_id": "80428793",
      "title": "Indoor Playroom",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_58f9a3c37e1a3265fc44affb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "yardi",
      "external_id": "87310408",
      "title": "Bark Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d496d-1791-7668-8504-7b11026b73e1.webp",
      "amenity_image_media": {
        "alt_text": "Creekside Village Apartments dog park entrance with etiquette sign",
        "public_id": "019d496d-1791-7668-8504-7b11026b73e1",
        "storage_key": "property/6767906449166889/019d496d-1791-7668-8504-7b11026b73e1.webp",
        "width": 2048,
        "height": 1463
      },
      "amenity_image_alt_text": "Bark Park View at Creekside Village, Oregon, 97401",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d12255609d15bbda42d320c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "yardi",
      "external_id": "86392825",
      "title": "24-Hour Package Lockers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d496d-1462-7498-87e1-25bfb67ad235.webp",
      "amenity_image_media": {
        "alt_text": "Amazon Hub lockers on the exterior of an apartment building.",
        "public_id": "019d496d-1462-7498-87e1-25bfb67ad235",
        "storage_key": "property/6767906449166889/019d496d-1462-7498-87e1-25bfb67ad235.webp",
        "width": 2048,
        "height": 1463
      },
      "amenity_image_alt_text": "24 Hour Self Serve Package Lockers at Creekside Village, Eugene, 97401",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1df491187ad21d5c9053ed35",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "yardi",
      "external_id": "80428794",
      "title": "Resident Activity Program – Summer pool party, food trucks, donation drive, and more!",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9cb9521898926af275a64778",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "yardi",
      "external_id": "86392823",
      "title": "Clubhouse Rentals",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d496c-dc2e-74db-907d-e7cce377bab8.webp",
      "amenity_image_media": {
        "alt_text": "Community lounge area with a kitchen, dining tables, and a fireplace.",
        "public_id": "019d496c-dc2e-74db-907d-e7cce377bab8",
        "storage_key": "property/6767906449166889/019d496c-dc2e-74db-907d-e7cce377bab8.webp",
        "width": 2048,
        "height": 1463
      },
      "amenity_image_alt_text": "Common Room at Creekside Village, Eugene, Oregon",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3ea006025db44737be012f43",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "yardi",
      "external_id": "82390146",
      "title": "Online Rent Payments",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3ba77f64039a70a6ef6dea9e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "yardi",
      "external_id": "82390148",
      "title": "Online Service Requests",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c5367aa32ba16e5b43717e6b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "yardi",
      "external_id": "124063038",
      "title": "Neighborhood Watch",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_659f865b22c89874811bffcd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "yardi",
      "external_id": "86392939",
      "title": "Smoke Free Housing",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_10429096e55d76063e6cb83a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "yardi",
      "external_id": "80428802",
      "title": "In-Unit Washer & Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d3346-fd43-747f-a84a-3b66e3398800.webp",
      "amenity_image_media": {
        "alt_text": "In-unit washer and dryer with overhead cabinets, laundry basket, and cleaning supplies. Bedroom visible through doorway.",
        "public_id": "019d3346-fd43-747f-a84a-3b66e3398800",
        "storage_key": "property/6767906449166889/019d3346-fd43-747f-a84a-3b66e3398800.webp",
        "width": 2048,
        "height": 1463
      },
      "amenity_image_alt_text": "Stacked Washer Dryer at Creekside Village, Eugene, 97401",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5e9797d6b39e7961916a37fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "yardi",
      "external_id": "80428800",
      "title": "Patio or Deck",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dcf1c57d3102fc0b08b60b5a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "yardi",
      "external_id": "80428799",
      "title": "Locked Patio/Deck Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3befd899d77a4e4f800d7d72",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "yardi",
      "external_id": "80428801",
      "title": "Walk-In Closets - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ef795507a32f6d4e1948e644",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "yardi",
      "external_id": "80428798",
      "title": "Vaulted Ceilings - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7be032588ca2f997c2159416",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "yardi",
      "external_id": "87310409",
      "title": "Built-In Vanity In Primary Bedroom - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d3346-fcdf-720e-9ae3-636b0632e9fe.webp",
      "amenity_image_media": {
        "alt_text": "Queen size bed with white bedding and navy and white accent pillows, next to a closet and a vanity area.",
        "public_id": "019d3346-fcdf-720e-9ae3-636b0632e9fe",
        "storage_key": "property/6767906449166889/019d3346-fcdf-720e-9ae3-636b0632e9fe.webp",
        "width": 2048,
        "height": 1463
      },
      "amenity_image_alt_text": "Large Bedroom With Closet at Creekside Village, Eugene, Oregon",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b7ef7620a195273ead9cf073",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "yardi",
      "external_id": "87310410",
      "title": "Scenic Views - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_6b81de321d20d2384ad0f597",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d42a4-3cb9-74b3-b53e-be997abc8b2f.webp",
      "image_media": {
        "alt_text": "Creekside Village Apartments monument sign with landscaping and apartment buildings in background.",
        "public_id": "019d42a4-3cb9-74b3-b53e-be997abc8b2f",
        "storage_key": "property/6767906449166889/019d42a4-3cb9-74b3-b53e-be997abc8b2f.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Welcome to Creekside Village Apartments, featuring beautiful landscaping and well-maintained apartment buildings. The monument sign clearly displays the property name and address.",
      "link": "false",
      "alt_text": "Creekside Village Apartments monument sign with landscaping and apartment buildings in background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CreeksideVillage_Eugene_OR_MonumentSign.jpg"
    },
    {
      "id": "ec_e4b3d451077d01600d7aebeb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d496c-a571-75b3-8a8e-ecd0ae7bd27b.webp",
      "image_media": {
        "alt_text": "Apartment complex exterior with a decorative waterfall and landscaping.",
        "public_id": "019d496c-a571-75b3-8a8e-ecd0ae7bd27b",
        "storage_key": "property/6767906449166889/019d496c-a571-75b3-8a8e-ecd0ae7bd27b.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Discover the serene beauty of our community's exterior, featuring a charming waterfall and lush landscaping that creates a tranquil ambiance.",
      "link": "false",
      "alt_text": "Apartment complex exterior with a decorative waterfall and landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CreeksideVillage_Eugene_OR_ClubhouseFountain(2).jpg"
    },
    {
      "id": "ec_fe28957ea31736903070ebc4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d3346-fdb8-757d-806e-895f2dd86204.webp",
      "image_media": {
        "alt_text": "Stone building with blue siding and large windows, surrounded by landscaping and a decorative bridge.",
        "public_id": "019d3346-fdb8-757d-806e-895f2dd86204",
        "storage_key": "property/6767906449166889/019d3346-fdb8-757d-806e-895f2dd86204.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Welcome to our community! This is the exterior of our clubhouse, featuring a beautiful stone facade, landscaping, and unique architectural details.",
      "link": "false",
      "alt_text": "Stone building with blue siding and large windows, surrounded by landscaping and a decorative bridge.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CreeksideVillage_Eugene_OR_ClubhouseBridgeEntry.jpg"
    },
    {
      "id": "ec_5645084564b04d5ad42dddc6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d1bf6-e14c-7139-aa75-b5c77aa823c6.webp",
      "image_media": {
        "alt_text": "Kitchen and dining area with a table set for a meal, black appliances, and a ceiling fan.",
        "public_id": "019d1bf6-e14c-7139-aa75-b5c77aa823c6",
        "storage_key": "property/6767906449166889/019d1bf6-e14c-7139-aa75-b5c77aa823c6.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Enjoy cooking and dining in this bright kitchen and dining area, featuring modern black appliances and a spacious table perfect for meals.",
      "link": "false",
      "alt_text": "Kitchen and dining area with a table set for a meal, black appliances, and a ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CreeksideVillage_Eugene_OR_ModelUpdatedKitchenDiningRoom.jpg"
    },
    {
      "id": "ec_326e64e53ccb83528bc5e579",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d1bf6-e08d-71eb-a155-2a40fffc166d.webp",
      "image_media": {
        "alt_text": "Kitchen and living room area in an apartment.",
        "public_id": "019d1bf6-e08d-71eb-a155-2a40fffc166d",
        "storage_key": "property/6767906449166889/019d1bf6-e08d-71eb-a155-2a40fffc166d.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "A bright and airy living space with a connected kitchen area featuring white cabinets and countertops. Perfect for comfortable living.",
      "link": "false",
      "alt_text": "Kitchen and living room area in an apartment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CreeksideVillage_Eugene_OR_ModelUpdatedKitchenLivingRoom.jpg"
    },
    {
      "id": "ec_0313f275a017ff3c543cc9ec",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d1bf6-e0a5-7299-bdb9-55003bb1bb77.webp",
      "image_media": {
        "alt_text": "Living room with a TV, coffee table, sofa, and dining area.",
        "public_id": "019d1bf6-e0a5-7299-bdb9-55003bb1bb77",
        "storage_key": "property/6767906449166889/019d1bf6-e0a5-7299-bdb9-55003bb1bb77.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Spacious living and dining area featuring a mounted TV, comfortable seating, and a dedicated dining space, perfect for entertaining or relaxing.",
      "link": "false",
      "alt_text": "Living room with a TV, coffee table, sofa, and dining area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CreeksideVillage_Eugene_OR_ModelLivingRoomHallway.jpg"
    },
    {
      "id": "ec_c9a1cfbeb8e7ebaa7ad75ee5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d496c-a577-73e2-94ae-a7ef52089038.webp",
      "image_media": {
        "alt_text": "Living room with dining area featuring a gray sofa, coffee table, and dining set.",
        "public_id": "019d496c-a577-73e2-94ae-a7ef52089038",
        "storage_key": "property/6767906449166889/019d496c-a577-73e2-94ae-a7ef52089038.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Bright and airy living and dining area with modern furnishings, perfect for relaxing or entertaining.",
      "link": "false",
      "alt_text": "Living room with dining area featuring a gray sofa, coffee table, and dining set.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CreeksideVillage_Eugene_OR_ModelLivingRoomDiningRoom(1).jpg"
    },
    {
      "id": "ec_fdb3c8106d2d43b366fd4040",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d1bf6-e8ea-767e-a09f-919899d3a9d4.webp",
      "image_media": {
        "alt_text": "Living room with sofa, coffee table, armchair, TV, and entertainment center.",
        "public_id": "019d1bf6-e8ea-767e-a09f-919899d3a9d4",
        "storage_key": "property/6767906449166889/019d1bf6-e8ea-767e-a09f-919899d3a9d4.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable sofa, a stylish coffee table, a cozy armchair, a mounted flat-screen TV, and a modern entertainment center.",
      "link": "false",
      "alt_text": "Living room with sofa, coffee table, armchair, TV, and entertainment center.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CreeksideVillage_Eugene_OR_ModelLivingRoomEntry.jpg"
    },
    {
      "id": "ec_1a465df5addda33bd7191776",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d1bf6-e0a2-7013-b66c-a7aa6000e289.webp",
      "image_media": {
        "alt_text": "Living room with a leather armchair, decorative art, and plants.",
        "public_id": "019d1bf6-e0a2-7013-b66c-a7aa6000e289",
        "storage_key": "property/6767906449166889/019d1bf6-e0a2-7013-b66c-a7aa6000e289.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Stylish living area featuring a comfortable leather armchair, contemporary wall art, and lush greenery, creating a welcoming atmosphere.",
      "link": "false",
      "alt_text": "Living room with a leather armchair, decorative art, and plants.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CreeksideVillage_Eugene_OR_ModelEntryNook.jpg"
    },
    {
      "id": "ec_3ea56a14a88c25f53b801d94",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d1bf6-e090-75b4-b11a-56840a7341ef.webp",
      "image_media": {
        "alt_text": "Primary bedroom with a queen-size bed, nightstands, and a closet.",
        "public_id": "019d1bf6-e090-75b4-b11a-56840a7341ef",
        "storage_key": "property/6767906449166889/019d1bf6-e090-75b4-b11a-56840a7341ef.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Cozy primary bedroom featuring a comfortable queen-size bed, decorative accents, and ample closet space for storage.",
      "link": "false",
      "alt_text": "Primary bedroom with a queen-size bed, nightstands, and a closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CreeksideVillage_Eugene_OR_ModelPrimaryBedroom(1).jpg"
    },
    {
      "id": "ec_cfc35413de5d65fc3e9fc32e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d3346-fcdf-720e-9ae3-636b0632e9fe.webp",
      "image_media": {
        "alt_text": "Queen size bed with white bedding and navy and white accent pillows, next to a closet and a vanity area.",
        "public_id": "019d3346-fcdf-720e-9ae3-636b0632e9fe",
        "storage_key": "property/6767906449166889/019d3346-fcdf-720e-9ae3-636b0632e9fe.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "A spacious bedroom featuring a comfortable queen-size bed, ample closet space, and a convenient vanity area, perfect for relaxation.",
      "link": "false",
      "alt_text": "Queen size bed with white bedding and navy and white accent pillows, next to a closet and a vanity area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CreeksideVillage_Eugene_OR_ModelPrimaryBedroomVanity(2).jpg"
    },
    {
      "id": "ec_70758e0233b2116ef9afadde",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d3346-fcdc-764a-8149-1b2fbf2c2fc0.webp",
      "image_media": {
        "alt_text": "A child's bedroom with a dinosaur theme, featuring a bed with dinosaur print comforter, a desk, and a chair.",
        "public_id": "019d3346-fcdc-764a-8149-1b2fbf2c2fc0",
        "storage_key": "property/6767906449166889/019d3346-fcdc-764a-8149-1b2fbf2c2fc0.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "This bedroom, decorated with a fun dinosaur theme, includes a comfortable bed, a desk for studying, and a playful atmosphere.",
      "link": "false",
      "alt_text": "A child's bedroom with a dinosaur theme, featuring a bed with dinosaur print comforter, a desk, and a chair.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CreeksideVillage_Eugene_OR_ModelSecondBedroom.jpg"
    },
    {
      "id": "ec_73075d877360dc4fe1ec5b2a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d3346-fcd6-706d-842e-d1c5e65ffbf4.webp",
      "image_media": {
        "alt_text": "Bedroom with a desk and chair, and a closet.",
        "public_id": "019d3346-fcd6-706d-842e-d1c5e65ffbf4",
        "storage_key": "property/6767906449166889/019d3346-fcd6-706d-842e-d1c5e65ffbf4.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Comfortable bedroom space featuring a desk, office chair, and ample closet storage. An adjacent room offers a glimpse of another bedroom.",
      "link": "false",
      "alt_text": "Bedroom with a desk and chair, and a closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CreeksideVillage_Eugene_OR_ModelSecondBedroomHallway(1).jpg"
    },
    {
      "id": "ec_e853fe4f4a103f87fa80b6a5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d3346-fcdf-720e-9ae3-66982518bd46.webp",
      "image_media": {
        "alt_text": "Clean and bright apartment bathroom with white vanity, sink, toilet, and bathtub with shower.",
        "public_id": "019d3346-fcdf-720e-9ae3-66982518bd46",
        "storage_key": "property/6767906449166889/019d3346-fcdf-720e-9ae3-66982518bd46.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "This apartment bathroom features a modern white vanity with ample storage, a bright sink area, a clean toilet, and a classic bathtub with a shower.",
      "link": "false",
      "alt_text": "Clean and bright apartment bathroom with white vanity, sink, toilet, and bathtub with shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CreeksideVillage_Eugene_OR_ModelBathroom(1).jpg"
    },
    {
      "id": "ec_074a1553e6435869cb40cae7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d3346-fd43-747f-a84a-3b66e3398800.webp",
      "image_media": {
        "alt_text": "In-unit washer and dryer with overhead cabinets, laundry basket, and cleaning supplies. Bedroom visible through doorway.",
        "public_id": "019d3346-fd43-747f-a84a-3b66e3398800",
        "storage_key": "property/6767906449166889/019d3346-fd43-747f-a84a-3b66e3398800.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Convenient in-unit laundry area featuring a washer and dryer, ample storage with overhead cabinets, and a laundry basket ready for use. The adjacent bedroom offers a glimpse of comfortable living.",
      "link": "false",
      "alt_text": "In-unit washer and dryer with overhead cabinets, laundry basket, and cleaning supplies. Bedroom visible through doorway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CreeksideVillage_Eugene_OR_ModelFullSizeWasherDryer(2).jpg"
    },
    {
      "id": "ec_94cd9a88c84484af11603f0b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d3346-fd55-711c-8846-e43692ed3ad3.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at the apartment complex.",
        "public_id": "019d3346-fd55-711c-8846-e43692ed3ad3",
        "storage_key": "property/6767906449166889/019d3346-fd55-711c-8846-e43692ed3ad3.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and shaded areas perfect for relaxation.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at the apartment complex.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CreeksideVillage_Eugene_OR_OutdoorSwimmingPoolClubhouseView.jpg"
    },
    {
      "id": "ec_aa25e622d54721fac4d94d20",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d496c-a5e0-7479-8c4b-df7794c3257d.webp",
      "image_media": {
        "alt_text": "A sparkling blue swimming pool with lounge chairs and umbrellas under a covered patio.",
        "public_id": "019d496c-a5e0-7479-8c4b-df7794c3257d",
        "storage_key": "property/6767906449166889/019d496c-a5e0-7479-8c4b-df7794c3257d.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our beautiful outdoor swimming pool, surrounded by lush greenery and comfortable lounge seating for ultimate relaxation.",
      "link": "false",
      "alt_text": "A sparkling blue swimming pool with lounge chairs and umbrellas under a covered patio.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CreeksideVillage_Eugene_OR_OutdoorSwimmingPoolDeck.jpg"
    },
    {
      "id": "ec_a2a54153a9091a19d83a42cc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d496c-a584-7457-b3d2-3c6dfa0923eb.webp",
      "image_media": {
        "alt_text": "An inviting swimming pool with lounge chairs and umbrellas, surrounded by lush greenery and apartment buildings.",
        "public_id": "019d496c-a584-7457-b3d2-3c6dfa0923eb",
        "storage_key": "property/6767906449166889/019d496c-a584-7457-b3d2-3c6dfa0923eb.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor swimming pool, complete with comfortable lounge chairs and shaded areas. Enjoy a refreshing dip on a warm day.",
      "link": "false",
      "alt_text": "An inviting swimming pool with lounge chairs and umbrellas, surrounded by lush greenery and apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CreeksideVillage_Eugene_OR_OutdoorSwimmingPoolFurniture.jpg"
    },
    {
      "id": "ec_b4ab3275e1a0f17b3427931e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d496c-a6ad-76d2-a78d-acc8db0e8489.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and trees.",
        "public_id": "019d496c-a6ad-76d2-a78d-acc8db0e8489",
        "storage_key": "property/6767906449166889/019d496c-a6ad-76d2-a78d-acc8db0e8489.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling outdoor pool, surrounded by lush landscaping and comfortable lounge seating.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CreeksideVillage_Eugene_OR_OutdoorSwimmingPool.jpg"
    },
    {
      "id": "ec_dc4fed00c17b0a9e2ce1f73c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d42a4-6222-748c-91a5-d28c1ecbac9d.webp",
      "image_media": {
        "alt_text": "Indoor jacuzzi with teal water and wood paneling.",
        "public_id": "019d42a4-6222-748c-91a5-d28c1ecbac9d",
        "storage_key": "property/6767906449166889/019d42a4-6222-748c-91a5-d28c1ecbac9d.webp",
        "width": 1024,
        "height": 732
      },
      "title": "Community",
      "description": "Relax and unwind in our indoor jacuzzi, featuring soothing teal waters and warm wood paneling for a tranquil atmosphere.",
      "link": "false",
      "alt_text": "Indoor jacuzzi with teal water and wood paneling.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CreeksideVillage_Eugene_OR_Spa.jpg"
    },
    {
      "id": "ec_fa63b4db65421f9ef3fd972f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d496c-ce8a-72c8-a3c7-dc233f9c1d70.webp",
      "image_media": {
        "alt_text": "Interior view of the property's leasing office lobby with a coffee bar and seating area.",
        "public_id": "019d496c-ce8a-72c8-a3c7-dc233f9c1d70",
        "storage_key": "property/6767906449166889/019d496c-ce8a-72c8-a3c7-dc233f9c1d70.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Welcome to our leasing office lobby, featuring a complimentary coffee bar and comfortable seating. This inviting space sets the tone for your new home.",
      "link": "false",
      "alt_text": "Interior view of the property's leasing office lobby with a coffee bar and seating area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CreeksideVillage_Eugene_OR_ClubhouseFoyer.jpg"
    },
    {
      "id": "ec_b4f3a708f52f7bb20161488f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d496c-dc91-7316-b724-aa307158f999.webp",
      "image_media": {
        "alt_text": "Creekside Cafe with complimentary coffee, hot cocoa, apple cider, and tea.",
        "public_id": "019d496c-dc91-7316-b724-aa307158f999",
        "storage_key": "property/6767906449166889/019d496c-dc91-7316-b724-aa307158f999.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Enjoy complimentary coffee, hot cocoa, apple cider, and tea at our Creekside Cafe.",
      "link": "false",
      "alt_text": "Creekside Cafe with complimentary coffee, hot cocoa, apple cider, and tea.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CreeksideVillage_Eugene_OR_ClubhouseCoffeeBar.jpg"
    },
    {
      "id": "ec_16e6de248b2b5efc7181ebe1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d496c-dc2e-74db-907d-e7cce377bab8.webp",
      "image_media": {
        "alt_text": "Community lounge area with a kitchen, dining tables, and a fireplace.",
        "public_id": "019d496c-dc2e-74db-907d-e7cce377bab8",
        "storage_key": "property/6767906449166889/019d496c-dc2e-74db-907d-e7cce377bab8.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Relax and socialize in our spacious community lounge, featuring a modern kitchen, comfortable seating, and a cozy fireplace perfect for gatherings.",
      "link": "false",
      "alt_text": "Community lounge area with a kitchen, dining tables, and a fireplace.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CreeksideVillage_Eugene_OR_ClubhouseSeating.jpg"
    },
    {
      "id": "ec_7c3d8cf173caefb87cb6cc44",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d496c-e782-714f-b0ba-41d17062d15a.webp",
      "image_media": {
        "alt_text": "Kitchen with dark wood cabinets, granite countertops, and a breakfast bar with stools.",
        "public_id": "019d496c-e782-714f-b0ba-41d17062d15a",
        "storage_key": "property/6767906449166889/019d496c-e782-714f-b0ba-41d17062d15a.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring dark wood cabinets, granite countertops, and a breakfast bar with seating, perfect for casual dining.",
      "link": "false",
      "alt_text": "Kitchen with dark wood cabinets, granite countertops, and a breakfast bar with stools.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CreeksideVillage_Eugene_OR_ClubhouseKitchen.jpg"
    },
    {
      "id": "ec_90c0bf8cdd1c76ea276118e1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d496c-dee4-779b-b390-57b744b69297.webp",
      "image_media": {
        "alt_text": "Living room with a stone fireplace, two accent chairs, and a coffee table.",
        "public_id": "019d496c-dee4-779b-b390-57b744b69297",
        "storage_key": "property/6767906449166889/019d496c-dee4-779b-b390-57b744b69297.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Relax and unwind in this cozy living room, featuring a charming stone fireplace and comfortable seating.",
      "link": "false",
      "alt_text": "Living room with a stone fireplace, two accent chairs, and a coffee table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CreeksideVillage_Eugene_OR_ClubhouseFireplaceLounge.jpg"
    },
    {
      "id": "ec_68cf973c46bea2cc57841fe8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d496c-f401-70ae-97f2-5847aaff85f4.webp",
      "image_media": {
        "alt_text": "Conference room with a large wooden table and white leather chairs.",
        "public_id": "019d496c-f401-70ae-97f2-5847aaff85f4",
        "storage_key": "property/6767906449166889/019d496c-f401-70ae-97f2-5847aaff85f4.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Host your next meeting in our well-appointed conference room, featuring a large table and comfortable seating.",
      "link": "false",
      "alt_text": "Conference room with a large wooden table and white leather chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CreeksideVillage_Eugene_OR_ConferenceRoom.jpg"
    },
    {
      "id": "ec_be6c8bc3d801fc6675fbac17",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d496d-067f-704b-b6ff-48124d4bb3c1.webp",
      "image_media": {
        "alt_text": "Business center with computers, printer, and seating area.",
        "public_id": "019d496d-067f-704b-b6ff-48124d4bb3c1",
        "storage_key": "property/6767906449166889/019d496d-067f-704b-b6ff-48124d4bb3c1.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Stay productive in our resident business center, equipped with computers, a printer, and a comfortable seating area for focused work.",
      "link": "false",
      "alt_text": "Business center with computers, printer, and seating area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CreeksideVillage_Eugene_OR_BusinessCenter(1).jpg"
    },
    {
      "id": "ec_e629ffb1ead2d56eb4cc5efe",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d496d-0d79-733b-9971-eda2329e66c0.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, and weight machines.",
        "public_id": "019d496d-0d79-733b-9971-eda2329e66c0",
        "storage_key": "property/6767906449166889/019d496d-0d79-733b-9971-eda2329e66c0.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with modern cardio and weight training equipment.",
      "link": "false",
      "alt_text": "Fitness center with treadmills, ellipticals, and weight machines.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CreeksideVillage_Eugene_OR_24HourFitnessCenter(1).jpg"
    },
    {
      "id": "ec_7baeacd3216fd1f50646e41f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d496d-1462-7498-87e1-25bfb67ad235.webp",
      "image_media": {
        "alt_text": "Amazon Hub lockers on the exterior of an apartment building.",
        "public_id": "019d496d-1462-7498-87e1-25bfb67ad235",
        "storage_key": "property/6767906449166889/019d496d-1462-7498-87e1-25bfb67ad235.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Secure Amazon Hub lockers are available for resident package delivery and pickup on the exterior of the community building.",
      "link": "false",
      "alt_text": "Amazon Hub lockers on the exterior of an apartment building.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CreeksideVillage_Eugene_OR_24HourSelfServePackageLockers.jpg"
    },
    {
      "id": "ec_d38969a5b3b63d1031462f69",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d496d-1791-7668-8504-7b11026b73e1.webp",
      "image_media": {
        "alt_text": "Creekside Village Apartments dog park entrance with etiquette sign",
        "public_id": "019d496d-1791-7668-8504-7b11026b73e1",
        "storage_key": "property/6767906449166889/019d496d-1791-7668-8504-7b11026b73e1.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Enjoy our dedicated dog park at Creekside Village Apartments, complete with rules and regulations for a safe and fun experience for all pets.",
      "link": "false",
      "alt_text": "Creekside Village Apartments dog park entrance with etiquette sign",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CreeksideVillage_Eugene_OR_BarkPark.jpg"
    },
    {
      "id": "ec_5b1d0361f8ab90e7a2c2b4bd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d496d-152e-72ce-a4e6-446555254b01.webp",
      "image_media": {
        "alt_text": "Property entrance with American flag and landscaping.",
        "public_id": "019d496d-152e-72ce-a4e6-446555254b01",
        "storage_key": "property/6767906449166889/019d496d-152e-72ce-a4e6-446555254b01.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Welcome to the property entrance, featuring a prominent American flag and beautifully maintained landscaping.",
      "link": "false",
      "alt_text": "Property entrance with American flag and landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CreeksideVillage_Eugene_OR_EntryRoundAbout.jpg"
    },
    {
      "id": "ec_88c997acf9a52bbf0be0cd88",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d496d-32e1-724a-b224-d7b7406c0cfd.webp",
      "image_media": {
        "alt_text": "Carports and bike racks outside apartment buildings.",
        "public_id": "019d496d-32e1-724a-b224-d7b7406c0cfd",
        "storage_key": "property/6767906449166889/019d496d-32e1-724a-b224-d7b7406c0cfd.webp",
        "width": 2048,
        "height": 1367
      },
      "title": "Community",
      "description": "Covered parking and bike storage available for residents.",
      "link": "false",
      "alt_text": "Carports and bike racks outside apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CreeksideVillage_Eugene_OR_ParkingLotBikeCages.jpg"
    },
    {
      "id": "ec_c37fd1c0d1e86c8240f6ab78",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d496d-36dd-72a5-9d66-aa312ee9dbc6.webp",
      "image_media": {
        "alt_text": "Exterior of a multifamily apartment building with blue and grey siding, grass, and bushes.",
        "public_id": "019d496d-36dd-72a5-9d66-aa312ee9dbc6",
        "storage_key": "property/6767906449166889/019d496d-36dd-72a5-9d66-aa312ee9dbc6.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "The exterior of the apartment building showcases a beautiful blend of blue and grey siding, complemented by lush green grass and manicured bushes, creating an inviting community atmosphere.",
      "link": "false",
      "alt_text": "Exterior of a multifamily apartment building with blue and grey siding, grass, and bushes.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CreeksideVillage_Eugene_OR_ThreeStoryBuildingExterior.jpg"
    },
    {
      "id": "ec_276475acbf1b30b0023fce1b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d496d-40f3-72f5-973f-0700fd9288ed.webp",
      "image_media": {
        "alt_text": "Exterior view of an apartment building with blue siding and a central staircase leading to the second floor.",
        "public_id": "019d496d-40f3-72f5-973f-0700fd9288ed",
        "storage_key": "property/6767906449166889/019d496d-40f3-72f5-973f-0700fd9288ed.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Discover comfortable living in this well-maintained apartment building, featuring exterior walkways and lush green landscaping.",
      "link": "false",
      "alt_text": "Exterior view of an apartment building with blue siding and a central staircase leading to the second floor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CreeksideVillage_Eugene_OR_TwoStoryBuildingExterior.jpg"
    },
    {
      "id": "ec_8be2bec6fb7102f09cc7f350",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d496d-492e-733c-bba1-c394dfd4e6df.webp",
      "image_media": {
        "alt_text": "A row of garages with white doors and blue siding.",
        "public_id": "019d496d-492e-733c-bba1-c394dfd4e6df",
        "storage_key": "property/6767906449166889/019d496d-492e-733c-bba1-c394dfd4e6df.webp",
        "width": 2048,
        "height": 1498
      },
      "title": "Community",
      "description": "A row of garages with white doors and blue siding, providing convenient parking and storage options for residents.",
      "link": "false",
      "alt_text": "A row of garages with white doors and blue siding.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CreeksideVillage_Eugene_OR_Garages(2).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_836cdd9b-03dd-4925-814e-8ac319bac32f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "3450 Gateway St, Springfield, OR 97477, USA",
      "poi_short_description": "Fast-food place specializing in chicken sandwiches, plus salads, lemonade and waffles.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken sandwiches, nuggets, and waffle fries. They also highlight the fast service, friendly staff, and clean atmosphere.\n\nOther reviews mention the food can be cold.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-4fea-761e-8ea3-9178fe19dde6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-4fea-761e-8ea3-9178fe19dde6",
        "storage_key": "property/6767906449166889/019d08ac-4fea-761e-8ea3-9178fe19dde6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/or/gateway-randy-pape-beltline?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=378869688699018296&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "44.083529",
      "poi_longitude": "-123.0421776",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 541-246-0385",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ab-fd4d-709a-b671-cf9f323bc16f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd4d-709a-b671-cf9f323bc16f",
        "storage_key": "property/6767906449166889/019d08ab-fd4d-709a-b671-cf9f323bc16f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJsUKACwDjwFQROFwRe_kDQgU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_53999a1b-62f5-4fee-81df-7cb8662b1842",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "1060 Valley River Way, Eugene, OR 97401, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, prime rib, and burgers, and the rolls with cinnamon butter are a highlight. They highlight the large portions, good value, and fun, vibrant atmosphere. They also like the attentive and friendly service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ab-6dca-76a6-8467-ac3d8853e0ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-6dca-76a6-8467-ac3d8853e0ef",
        "storage_key": "property/6767906449166889/019d08ab-6dca-76a6-8467-ac3d8853e0ef.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/oregon/eugene?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=5468141731452874753&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "44.0685776",
      "poi_longitude": "-123.1036208",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 541-345-7427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ab-fd4d-709a-b671-cf9f323bc16f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd4d-709a-b671-cf9f323bc16f",
        "storage_key": "property/6767906449166889/019d08ab-fd4d-709a-b671-cf9f323bc16f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJe1Tse-QdwVQRAfC87O694ks",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_972290b4-f5e8-4b0a-8521-9dbab7cb614b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "custom",
      "poi_name": "Dave's Hot Chicken",
      "poi_type": "Restaurants",
      "poi_address": "1285 Alder St, Eugene, OR 97401, USA",
      "poi_short_description": "Casual eatery serving fried chicken dishes, like sliders and tenders, plus sauces.",
      "poi_long_description": "People say this chicken restaurant serves delicious hot chicken sandwiches, sliders, and tenders, with a variety of spice levels. They highlight the generous portions, reasonable prices, and the fun, rebellious atmosphere. They also like the friendly and helpful staff, and the fast service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-5011-70bb-bfd7-dc3a436ed596.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-5011-70bb-bfd7-dc3a436ed596",
        "storage_key": "property/6767906449166889/019d08ac-5011-70bb-bfd7-dc3a436ed596.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.daveshotchicken.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9992617700058883397&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "daves-hot-chicken",
      "poi_latitude": "44.045713",
      "poi_longitude": "-123.0799335",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 541-790-2399",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ab-fd4d-709a-b671-cf9f323bc16f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd4d-709a-b671-cf9f323bc16f",
        "storage_key": "property/6767906449166889/019d08ab-fd4d-709a-b671-cf9f323bc16f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJMzusFegfwVQRRWVK5NrorIo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_a4458845-04d9-4a4a-a731-65e09e177111",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "custom",
      "poi_name": "PublicHouse",
      "poi_type": "Restaurants",
      "poi_address": "418 A St #4606, Springfield, OR 97477, USA",
      "poi_short_description": "Casual eatery serving local beers and ciders alongside a variety of cuisines from multiple vendors.",
      "poi_long_description": "People say this restaurant offers a great selection of beer, cider, and whiskey, as well as diverse food options like poke bowls, shawarma, and pizza. They highlight the unique and fantastic ambiance of the old church building, and the spacious outdoor seating. They also like the friendly staff and quick service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-5059-703d-9dab-3c985edffefb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-5059-703d-9dab-3c985edffefb",
        "storage_key": "property/6767906449166889/019d08ac-5059-703d-9dab-3c985edffefb.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.publichousehub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7451647777145764061&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "publichouse",
      "poi_latitude": "44.0473145",
      "poi_longitude": "-123.020483",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 541-246-8511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ab-fd4d-709a-b671-cf9f323bc16f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd4d-709a-b671-cf9f323bc16f",
        "storage_key": "property/6767906449166889/019d08ab-fd4d-709a-b671-cf9f323bc16f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJhc2Uc-zhwFQR3TgaPCySaWc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_c0d0fe70-6904-49a9-a912-329482b8673a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "custom",
      "poi_name": "McMenamins North Bank",
      "poi_type": "Restaurants",
      "poi_address": "22 Club Rd, Eugene, OR 97401, USA",
      "poi_short_description": "Laid-back brewpub chain outlet offering American bites, plus beer, cider, cocktails, and wine, in a scenic riverside setting.",
      "poi_long_description": "People say this brewpub offers delicious burgers, fries, and salmon, as well as a variety of salads and other dishes. They also highlight the beautiful river view, the friendly and attentive staff, and the cozy, rustic atmosphere.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-51e1-7534-9b5c-16449fe74fbc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-51e1-7534-9b5c-16449fe74fbc",
        "storage_key": "property/6767906449166889/019d08ac-51e1-7534-9b5c-16449fe74fbc.webp",
        "width": 500,
        "height": 375
      },
      "poi_business_url": "https://www.mcmenamins.com/north-bank?utm_source=Google%20Maps&utm_medium=Website%20Button&utm_campaign=North%20Bank",
      "poi_directions_map_url": "https://maps.google.com/?cid=18087913349017827211&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mcmenamins-north-bank",
      "poi_latitude": "44.0595576",
      "poi_longitude": "-123.0849531",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 541-343-5622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-0809-72f3-b037-7e825bbffabc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-0809-72f3-b037-7e825bbffabc",
        "storage_key": "property/6767906449166889/019d08ac-0809-72f3-b037-7e825bbffabc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ28sqPQUewVQRi_dAaFstBfs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pub"
    },
    {
      "id": "custom_a3aab3e3-eccf-41ad-855c-3c13daeeccc7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "custom",
      "poi_name": "Valley River Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "293 Valley River Center, Eugene, OR 97401, USA",
      "poi_short_description": "Shopping center with a familiar setup of department stores & boutiques, plus a food court & cinema.",
      "poi_long_description": "Shopping center with a familiar setup of department stores & boutiques, plus a food court & cinema.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ab-8d58-70a5-a6a1-d241c19900c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-8d58-70a5-a6a1-d241c19900c9",
        "storage_key": "property/6767906449166889/019d08ab-8d58-70a5-a6a1-d241c19900c9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.valleyrivercenter.com/?utm_source=google&utm_medium=onlinesearch&utm_content=gmp_website_button&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=11792628603146880467&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "valley-river-center",
      "poi_latitude": "44.0681158",
      "poi_longitude": "-123.1060016",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 541-683-5513",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ab-fd5b-734d-bd03-660f89b36a1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd5b-734d-bd03-660f89b36a1a",
        "storage_key": "property/6767906449166889/019d08ab-fd5b-734d-bd03-660f89b36a1a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJJdNcJuQdwVQR00WuCjzVp6M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_37df5055-d796-4a7b-9b8e-27767d2c9d87",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "85 Oakway Center, Eugene, OR 97401, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "People say this grocery store offers unique items, a wide variety of options, and fresh flowers. They highlight the low to normal prices, and the fun, cozy vibe. They also like the friendly, upbeat, and helpful staff.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://locations.traderjoes.com/or/eugene/145/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=4807059823773155437&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "44.0662723",
      "poi_longitude": "-123.0752647",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 541-485-1744",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ab-fd36-7507-bf88-286bc80c6522.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd36-7507-bf88-286bc80c6522",
        "storage_key": "property/6767906449166889/019d08ab-fd36-7507-bf88-286bc80c6522.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKwYiKvzhwFQRbQAN2nAbtkI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_66766e29-9da7-448f-8f05-c710eef1f3f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "353 E Broadway, Eugene, OR 97401, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "People say this grocery store offers a great selection of organic food, a delicious salad bar, and a convenient Amazon return counter. They also highlight the friendly and helpful staff, and the clean and well-organized environment.\n\nSome reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-580d-70d8-b463-f5f9a390d202.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-580d-70d8-b463-f5f9a390d202",
        "storage_key": "property/6767906449166889/019d08ac-580d-70d8-b463-f5f9a390d202.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/eugene?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=13670538195113176270&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "44.0503376",
      "poi_longitude": "-123.0878329",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 541-434-8820",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ab-fd36-7507-bf88-286bc80c6522.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd36-7507-bf88-286bc80c6522",
        "storage_key": "property/6767906449166889/019d08ab-fd36-7507-bf88-286bc80c6522.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_7qpsxUewVQRzmwhEA-Ct70",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_5274a599-23b3-4e63-b7f9-3f7ae7511c2c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "custom",
      "poi_name": "Safeway",
      "poi_type": "Shopping & Retail",
      "poi_address": "145 E 18th Ave, Eugene, OR 97401, USA",
      "poi_short_description": "Longtime supermarket chain carrying brand-name & house-label groceries, plus a deli, bakery & more.",
      "poi_long_description": "People say this grocery store offers high-quality produce, meat, bakery, and deli food. They also highlight the friendly and helpful staff, and the convenient location with easy parking.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-5768-76b9-8936-ad5187bbb5d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-5768-76b9-8936-ad5187bbb5d6",
        "storage_key": "property/6767906449166889/019d08ac-5768-76b9-8936-ad5187bbb5d6.webp",
        "width": 853,
        "height": 480
      },
      "poi_business_url": "https://local.safeway.com/safeway/or/eugene/145-e-18th-ave.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=13608189488765557769&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "safeway",
      "poi_latitude": "44.0405404",
      "poi_longitude": "-123.0906309",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 541-485-5051",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ab-fd36-7507-bf88-286bc80c6522.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd36-7507-bf88-286bc80c6522",
        "storage_key": "property/6767906449166889/019d08ab-fd36-7507-bf88-286bc80c6522.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP8lqFkQewVQRCVwToj0A2rw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_c52c4f49-bd64-4620-bbf6-34574cf5b5e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "2815 Chad Dr, Eugene, OR 97408, USA",
      "poi_short_description": "Employee-owned store featuring organic foods, a deli counter and a bakery.",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh produce, bulk goods, and other groceries. They highlight the low prices, convenient 24-hour operation, and employee-owned structure. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-59c3-719d-8da7-f18e7ea8d2d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-59c3-719d-8da7-f18e7ea8d2d9",
        "storage_key": "property/6767906449166889/019d08ac-59c3-719d-8da7-f18e7ea8d2d9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10811697610709635809&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "44.0923012",
      "poi_longitude": "-123.066993",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 458-210-3312",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ab-fd36-7507-bf88-286bc80c6522.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd36-7507-bf88-286bc80c6522",
        "storage_key": "property/6767906449166889/019d08ab-fd36-7507-bf88-286bc80c6522.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDzHWKOfjwFQR4ZJJsbHdCpY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_8d3765e8-d9e4-45bc-a7b7-accfa4d357d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "custom",
      "poi_name": "University of Oregon",
      "poi_type": "Education",
      "poi_address": "1585 E 13th Ave, Eugene, OR 97403, USA",
      "poi_short_description": "Public research school founded in 1876 & known for its sports & education programs.",
      "poi_long_description": "Public research school founded in 1876 & known for its sports & education programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ab-a37e-758f-abec-4ecca1fee5cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-a37e-758f-abec-4ecca1fee5cd",
        "storage_key": "property/6767906449166889/019d08ab-a37e-758f-abec-4ecca1fee5cd.webp",
        "width": 680,
        "height": 484
      },
      "poi_business_url": "http://www.uoregon.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2497941177432973622&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-of-oregon",
      "poi_latitude": "44.0448302",
      "poi_longitude": "-123.0726055",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 541-346-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-02a0-717b-aa81-ab81de19c9b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-02a0-717b-aa81-ab81de19c9b2",
        "storage_key": "property/6767906449166889/019d08ac-02a0-717b-aa81-ab81de19c9b2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJry4WWzoewVQRNqG2JkR4qiI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_d320fe19-138a-46ee-930c-2bd722cec484",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "custom",
      "poi_name": "Eugene Public Library - Downtown",
      "poi_type": "Education",
      "poi_address": "100 W 10th Ave, Eugene, OR 97401, USA",
      "poi_short_description": "Public library with a wide selection of books, story times, and activities, plus computers.",
      "poi_long_description": "People say this public library offers a wide selection of books, magazines, audiobooks, video games, and other items, including cake pans and board games. They also highlight the comfortable chairs, quiet reading and work rooms, and the availability of computers, study rooms, and a seed library.\n\nOther reviews mention the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-5c45-766b-986d-280b2c7fac89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-5c45-766b-986d-280b2c7fac89",
        "storage_key": "property/6767906449166889/019d08ac-5c45-766b-986d-280b2c7fac89.webp",
        "width": 628,
        "height": 1280
      },
      "poi_business_url": "http://www.eugene-or.gov/library",
      "poi_directions_map_url": "https://maps.google.com/?cid=11682320372394889646&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "eugene-public-library---downtown",
      "poi_latitude": "44.0485278",
      "poi_longitude": "-123.0948639",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 541-682-5450",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-02a0-717b-aa81-ab81de19c9b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-02a0-717b-aa81-ab81de19c9b2",
        "storage_key": "property/6767906449166889/019d08ac-02a0-717b-aa81-ab81de19c9b2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJe-PDmsewVQRrhHorHvwH6I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_62bcc409-9f65-4aef-9fa0-1019c3c2ce9f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "custom",
      "poi_name": "Knight Library",
      "poi_type": "Education",
      "poi_address": "1501 Kincaid St, Eugene, OR 97403, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-6217-7675-b0f4-985b685fce37.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-6217-7675-b0f4-985b685fce37",
        "storage_key": "property/6767906449166889/019d08ac-6217-7675-b0f4-985b685fce37.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://library.uoregon.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3985723467093524122&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "knight-library",
      "poi_latitude": "44.0431902",
      "poi_longitude": "-123.0777292",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 541-346-3065",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-116b-724f-a358-c8a58aa7a270.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-116b-724f-a358-c8a58aa7a270",
        "storage_key": "property/6767906449166889/019d08ac-116b-724f-a358-c8a58aa7a270.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ05gaDjkewVQRmj4MRWAiUDc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_c94e7dab-86ee-4dbe-8aa5-aa3c1f9ebba2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "custom",
      "poi_name": "Autzen Stadium",
      "poi_type": "Entertainment",
      "poi_address": "2700 Martin Luther King Jr Blvd, Eugene, OR 97401, USA",
      "poi_short_description": "54,000-seat outdoor football stadium, built in 1967, hosting University of Oregon Ducks games.",
      "poi_long_description": "People say this stadium offers a fun and exciting college football experience. They highlight the high energy, loud atmosphere, and passionate fans. They also like the beautiful views of the surrounding natural landscape.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-6269-723b-977d-7c49d1f3155f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-6269-723b-977d-7c49d1f3155f",
        "storage_key": "property/6767906449166889/019d08ac-6269-723b-977d-7c49d1f3155f.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://goducks.com/sports/2011/6/21/205174790.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=5408670694213009624&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "autzen-stadium",
      "poi_latitude": "44.0582608",
      "poi_longitude": "-123.0684924",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 541-346-4461",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-9254-750e-bef9-aa7a7ba28f4b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-9254-750e-bef9-aa7a7ba28f4b",
        "storage_key": "property/6767906449166889/019d08ac-9254-750e-bef9-aa7a7ba28f4b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJh8FmphYewVQR2MChC1d1D0s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_19eeb58f-45da-4a2f-b164-d469c92b2a02",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "custom",
      "poi_name": "Hayward Field",
      "poi_type": "Entertainment",
      "poi_address": "1530 Agate St, Eugene, OR 97403, USA",
      "poi_short_description": "Home to the Oregon Ducks, this historic track & field stadium hosts the annual Prefontaine Classic.",
      "poi_long_description": "People say this stadium is an amazing track and field venue with great views of the track from anywhere in the stadium. They highlight the phenomenal experience for both competing and spectating, and the convenient access to nearby housing. They also like the comfortable cushioned seats, massive screens, and upbeat music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-628e-7539-87c0-9fe82a533bfe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-628e-7539-87c0-9fe82a533bfe",
        "storage_key": "property/6767906449166889/019d08ac-628e-7539-87c0-9fe82a533bfe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://hayward.uoregon.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13856145649325384440&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hayward-field",
      "poi_latitude": "44.04240679999999",
      "poi_longitude": "-123.070692",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 541-346-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-9254-750e-bef9-aa7a7ba28f4b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-9254-750e-bef9-aa7a7ba28f4b",
        "storage_key": "property/6767906449166889/019d08ac-9254-750e-bef9-aa7a7ba28f4b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJvRiHhjAewVQR-CIdGA7rSsA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_3b03fd93-89ec-4bd7-a494-5ee9be009a4a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "custom",
      "poi_name": "Matthew Knight Arena",
      "poi_type": "Entertainment",
      "poi_address": "1390 Villard St, Eugene, OR 97403, USA",
      "poi_short_description": "12,364-seat University of Oregon basketball arena with a huge scoreboard & iconic court design.",
      "poi_long_description": "People say this arena hosts basketball games, concerts, and other events. They highlight the beautiful court, comfortable seats, and the facility's amenities, including food and beverage options. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-6480-712b-a5db-650b4d1a64a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-6480-712b-a5db-650b4d1a64a5",
        "storage_key": "property/6767906449166889/019d08ac-6480-712b-a5db-650b4d1a64a5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://goducks.com/MKA",
      "poi_directions_map_url": "https://maps.google.com/?cid=860175736518615271&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "matthew-knight-arena",
      "poi_latitude": "44.0449193",
      "poi_longitude": "-123.066311",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 541-346-4461",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-02af-7499-8603-4afd9cb8c9d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-02af-7499-8603-4afd9cb8c9d5",
        "storage_key": "property/6767906449166889/019d08ac-02af-7499-8603-4afd9cb8c9d5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB8IkbyUewVQR5yCaY0b17ws",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_2db4499c-1b27-4577-8c3c-a6b87fa0877c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "custom",
      "poi_name": "Museum of Natural and Cultural History",
      "poi_type": "Entertainment",
      "poi_address": "1680 E 15th Ave, Eugene, OR 97401, USA",
      "poi_short_description": "Small museum affiliated with the U of O showcasing ancient NW peoples & animals, geology & botany.",
      "poi_long_description": "People say this museum offers interactive exhibits and a ton of information regarding the geological history of Oregon. They highlight the engaging and thought-provoking experience, suitable for all ages. They also like the connection to local history.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ab-b5a5-7040-b05b-6e77df4dc26e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-b5a5-7040-b05b-6e77df4dc26e",
        "storage_key": "property/6767906449166889/019d08ab-b5a5-7040-b05b-6e77df4dc26e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://mnch.uoregon.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7107081899723103616&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "museum-of-natural-and-cultural-history",
      "poi_latitude": "44.0430077",
      "poi_longitude": "-123.0680746",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 541-346-3024",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-0380-70a4-81b0-386b1589d28a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-0380-70a4-81b0-386b1589d28a",
        "storage_key": "property/6767906449166889/019d08ac-0380-70a4-81b0-386b1589d28a.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJM7kRDTAewVQRgJ2aNlVtoWI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_b33402e7-69d8-4536-9582-734d7d574438",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "custom",
      "poi_name": "Eugene Science Center",
      "poi_type": "Entertainment",
      "poi_address": "2300 Leo Harris Pkwy, Eugene, OR 97401, USA",
      "poi_short_description": "Kid-focused museum featuring rotating hands-on science exhibits & a planetarium.",
      "poi_long_description": "Kid-focused museum featuring rotating hands-on science exhibits & a planetarium.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ab-a819-72cb-8030-59ca9b3a5bdf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-a819-72cb-8030-59ca9b3a5bdf",
        "storage_key": "property/6767906449166889/019d08ab-a819-72cb-8030-59ca9b3a5bdf.webp",
        "width": 960,
        "height": 377
      },
      "poi_business_url": "http://www.eugenesciencecenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15280184801734922711&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "eugene-science-center",
      "poi_latitude": "44.05647279999999",
      "poi_longitude": "-123.0727371",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 541-682-7888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-0380-70a4-81b0-386b1589d28a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-0380-70a4-81b0-386b1589d28a",
        "storage_key": "property/6767906449166889/019d08ac-0380-70a4-81b0-386b1589d28a.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJGaoMlh4ewVQR15G7iR4fDtQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_21422a16-3fc3-47de-b42e-884025864f47",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "custom",
      "poi_name": "Eugene Family YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "600 E 24th Ave, Eugene, OR 97405, USA",
      "poi_short_description": "Community-focused spot offering an array of fitness classes, a basketball court and a clean gym, plus a hot tub and a pool.",
      "poi_long_description": "People say this gym offers a wide variety of classes, modern equipment, and a large selection of free weights. They also highlight the clean facilities, including a pool, hot tub, and sauna, and the friendly and welcoming staff.\n\nOther reviews mention it can be crowded.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.eugeneymca.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11297189031581326358&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "eugene-family-ymca",
      "poi_latitude": "44.0330857",
      "poi_longitude": "-123.082585",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 541-686-9622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-02af-7499-8603-4afd9cb8c9d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-02af-7499-8603-4afd9cb8c9d5",
        "storage_key": "property/6767906449166889/019d08ac-02af-7499-8603-4afd9cb8c9d5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpfZW20gewVQRFhzYs5Gtx5w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_16557825-4e3e-4e37-91af-99d580236598",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2370 W 11th Ave, Eugene, OR 97402, USA",
      "poi_short_description": "Clean, spacious gym chain featuring treadmills and massage chairs alongside weight equipment.",
      "poi_long_description": "Some gym goers say this gym offers a clean and welcoming environment with friendly staff and well-maintained machines, and many appreciate the affordable prices.\n\nOther reviews mention the customer service can be unhelpful and management can be unresponsive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ab-c37b-73e0-9cd2-f7857417c086.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-c37b-73e0-9cd2-f7857417c086",
        "storage_key": "property/6767906449166889/019d08ab-c37b-73e0-9cd2-f7857417c086.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/eugene-or?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=6475030362409239520&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "44.0470795",
      "poi_longitude": "-123.1292825",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 541-465-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-02af-7499-8603-4afd9cb8c9d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-02af-7499-8603-4afd9cb8c9d5",
        "storage_key": "property/6767906449166889/019d08ac-02af-7499-8603-4afd9cb8c9d5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEbHwmgUfwVQR4INF9c7t21k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_1d838ac3-4e62-4c60-b7a0-296eb0165479",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "custom",
      "poi_name": "Crunch Fitness - Eugene-Springfield",
      "poi_type": "Health and Wellness",
      "poi_address": "3000 Gateway St Eugene, Springfield, OR 97477, USA",
      "poi_short_description": "Fitness center featuring free weights, machines and group classes along with personal trainers.",
      "poi_long_description": "Some gym goers say this gym has a wide variety of workout equipment, including free weights and machines, and a spacious layout.\n\nOther reviews mention the billing can be inaccurate and customer service can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-6b82-730c-a893-27540979d900.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-6b82-730c-a893-27540979d900",
        "storage_key": "property/6767906449166889/019d08ac-6b82-730c-a893-27540979d900.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.crunch.com/locations/eugene",
      "poi_directions_map_url": "https://maps.google.com/?cid=8979826685937905877&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---eugene-springfield",
      "poi_latitude": "44.075603",
      "poi_longitude": "-123.0446226",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 458-275-0399",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-02af-7499-8603-4afd9cb8c9d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-02af-7499-8603-4afd9cb8c9d5",
        "storage_key": "property/6767906449166889/019d08ac-02af-7499-8603-4afd9cb8c9d5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6aU3ilXhwFQR1fDmL8vAnnw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_2972188e-8887-4a97-966a-338f76cea1af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "3000 Gateway St Suite 222, Springfield, OR 97477, USA",
      "poi_short_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-6b94-728a-8dd9-f6055209e1b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-6b94-728a-8dd9-f6055209e1b8",
        "storage_key": "property/6767906449166889/019d08ac-6b94-728a-8dd9-f6055209e1b8.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/springfield-or-1129",
      "poi_directions_map_url": "https://maps.google.com/?cid=2639722503019479692&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "44.0742593",
      "poi_longitude": "-123.0449882",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 541-746-5052",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-02af-7499-8603-4afd9cb8c9d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-02af-7499-8603-4afd9cb8c9d5",
        "storage_key": "property/6767906449166889/019d08ac-02af-7499-8603-4afd9cb8c9d5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJl3vz1I3hwFQRjMIUcqEtoiQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_1c5cb3aa-5c25-4452-8f27-0ddd8cf8a2a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "custom",
      "poi_name": "Emergency Veterinary Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "1821 Pioneer Pkwy E, Springfield, OR 97477, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-6cbc-7434-b855-80a9ebe7d8a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-6cbc-7434-b855-80a9ebe7d8a4",
        "storage_key": "property/6767906449166889/019d08ac-6cbc-7434-b855-80a9ebe7d8a4.webp",
        "width": 1203,
        "height": 808
      },
      "poi_business_url": "https://www.emergencyvethosp.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2212067546168990547&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "emergency-veterinary-hospital",
      "poi_latitude": "44.0636884",
      "poi_longitude": "-123.0259037",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 541-746-0112",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-02af-7499-8603-4afd9cb8c9d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-02af-7499-8603-4afd9cb8c9d5",
        "storage_key": "property/6767906449166889/019d08ac-02af-7499-8603-4afd9cb8c9d5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd9OYCbzhwFQRU5uSlLbXsh4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_e91a12ef-e5f8-4aa2-9715-3ad341c56516",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "custom",
      "poi_name": "West Coast Strength",
      "poi_type": "Health and Wellness",
      "poi_address": "2728 Pheasant Blvd, Springfield, OR 97477, USA",
      "poi_short_description": "Workout facility offering a range of classes and a variety of equipment, plus a pool.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including machines, free weights, and a basketball court, as well as amenities like saunas and a daycare. They highlight the clean and spacious facility, and the friendly and welcoming atmosphere. They also like the knowledgeable and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-6d32-715c-a64c-17c51dc3c724.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-6d32-715c-a64c-17c51dc3c724",
        "storage_key": "property/6767906449166889/019d08ac-6d32-715c-a64c-17c51dc3c724.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://westcoaststrength.com/springfield",
      "poi_directions_map_url": "https://maps.google.com/?cid=13236955589819928487&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "west-coast-strength",
      "poi_latitude": "44.07242859999999",
      "poi_longitude": "-123.0346304",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 458-273-4356",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-02af-7499-8603-4afd9cb8c9d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-02af-7499-8603-4afd9cb8c9d5",
        "storage_key": "property/6767906449166889/019d08ac-02af-7499-8603-4afd9cb8c9d5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJG13bxVPhwFQRp4_W_vkcs7c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_5f28a980-b65b-4f05-beba-3b758aefffe1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "custom",
      "poi_name": "Bounce Gymnastics & Aerial Arts Center",
      "poi_type": "Health and Wellness",
      "poi_address": "329 W 3rd Ave, Eugene, OR 97401, USA",
      "poi_short_description": "Kid-friendly gymnastics center that hosts birthday parties and offers classes for a range of ages.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-735e-74e7-aa21-39a949a3651a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-735e-74e7-aa21-39a949a3651a",
        "storage_key": "property/6767906449166889/019d08ac-735e-74e7-aa21-39a949a3651a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.bouncegymnastics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2211618177328752565&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bounce-gymnastics--aerial-arts-center",
      "poi_latitude": "44.0567976",
      "poi_longitude": "-123.0976828",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 541-343-4222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-02a0-717b-aa81-ab81de19c9b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-02a0-717b-aa81-ab81de19c9b2",
        "storage_key": "property/6767906449166889/019d08ac-02a0-717b-aa81-ab81de19c9b2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJbe8iBw0ewVQRtSd6vgM_sR4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_1f8ecd9d-c6cc-4cc2-a4f4-f3beb636582e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "custom",
      "poi_name": "Pursue Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "555 W Centennial Blvd, Springfield, OR 97477, USA",
      "poi_short_description": "Gym with cardio and weight equipment, tanning beds, massage chairs, and childcare, plus 24-hour access.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-732e-7586-af1d-35f67e793dd5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-732e-7586-af1d-35f67e793dd5",
        "storage_key": "property/6767906449166889/019d08ac-732e-7586-af1d-35f67e793dd5.webp",
        "width": 1280,
        "height": 733
      },
      "poi_business_url": "https://pursuefitness.club/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17788707790243463202&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pursue-fitness",
      "poi_latitude": "44.0564536",
      "poi_longitude": "-123.0348054",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 541-735-3265",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-02af-7499-8603-4afd9cb8c9d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-02af-7499-8603-4afd9cb8c9d5",
        "storage_key": "property/6767906449166889/019d08ac-02af-7499-8603-4afd9cb8c9d5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ165dU8bhwFQRIoCvknwv3vY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_835f16d0-90e1-4d6f-8bc7-ff1b32fc431c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "custom",
      "poi_name": "Wilvet South",
      "poi_type": "Health and Wellness",
      "poi_address": "444 B St, Springfield, OR 97477, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-739f-7317-acda-2605144a2a70.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-739f-7317-acda-2605144a2a70",
        "storage_key": "property/6767906449166889/019d08ac-739f-7317-acda-2605144a2a70.webp",
        "width": 514,
        "height": 640
      },
      "poi_business_url": "https://wilvetsouth.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17338343674271256025&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wilvet-south",
      "poi_latitude": "44.0481614",
      "poi_longitude": "-123.0203697",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 541-838-0577",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-02af-7499-8603-4afd9cb8c9d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-02af-7499-8603-4afd9cb8c9d5",
        "storage_key": "property/6767906449166889/019d08ac-02af-7499-8603-4afd9cb8c9d5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf3IPsgfhwFQR2U2UkrUrnvA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_cadc7a77-5937-4e0b-9fcb-1471bc6a36ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "custom",
      "poi_name": "National Academy of Artistic Gymnastics",
      "poi_type": "Health and Wellness",
      "poi_address": "1205 Oak Patch Rd I, Eugene, OR 97402, USA",
      "poi_short_description": "Area for open gyms, birthday parties, recreational and competitive gymnastics, with attentive coaches.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-7590-7539-b276-956e43ef6078.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-7590-7539-b276-956e43ef6078",
        "storage_key": "property/6767906449166889/019d08ac-7590-7539-b276-956e43ef6078.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.naag-gymnastics.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18308426768454856094&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "national-academy-of-artistic-gymnastics",
      "poi_latitude": "44.046825",
      "poi_longitude": "-123.1349806",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 541-344-2002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-02a0-717b-aa81-ab81de19c9b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-02a0-717b-aa81-ab81de19c9b2",
        "storage_key": "property/6767906449166889/019d08ac-02a0-717b-aa81-ab81de19c9b2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJw3RtDoQewVQRni0ByiSZFP4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_88fc72a4-ec08-40a1-8af8-dfa6c2b60a96",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "custom",
      "poi_name": "PeaceHealth Sacred Heart Medical Center RiverBend",
      "poi_type": "Health and Wellness",
      "poi_address": "3333 Riverbend Dr, Springfield, OR 97477, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ab-b8e5-75ff-a8a8-800e400f4263.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-b8e5-75ff-a8a8-800e400f4263",
        "storage_key": "property/6767906449166889/019d08ab-b8e5-75ff-a8a8-800e400f4263.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.peacehealth.org/hospitals/peacehealth-sacred-heart-medical-center-riverbend?utm_source=gbp&utm_medium=organic&utm_content=SPRI-000&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=3786559555671786971&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "peacehealth-sacred-heart-medical-center-riverbend",
      "poi_latitude": "44.0812925",
      "poi_longitude": "-123.0265541",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 541-222-7300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-081b-762a-9491-b11627256494.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-081b-762a-9491-b11627256494",
        "storage_key": "property/6767906449166889/019d08ac-081b-762a-9491-b11627256494.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJiTENnnjhwFQR24WtlNqPjDQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_b296b511-d50d-4bc0-970e-c39f490cbc8a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "custom",
      "poi_name": "McKenzie Medical Center - Springfield",
      "poi_type": "Health and Wellness",
      "poi_address": "1460 G St, Springfield, OR 97477, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-7b35-725b-beb6-b2d2134187ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-7b35-725b-beb6-b2d2134187ba",
        "storage_key": "property/6767906449166889/019d08ac-7b35-725b-beb6-b2d2134187ba.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.mckweb.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16077342775418877766&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mckenzie-medical-center---springfield",
      "poi_latitude": "44.0533434",
      "poi_longitude": "-123.0030054",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 541-726-4400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-081b-762a-9491-b11627256494.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-081b-762a-9491-b11627256494",
        "storage_key": "property/6767906449166889/019d08ac-081b-762a-9491-b11627256494.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJSyBRPFPgwFQRRvcIpRIyHt8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_547b5bba-3d1a-482f-8543-763ebd5ce6d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "custom",
      "poi_name": "Alton Baker Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "200 Day Island Rd, Eugene, OR 97401, USA",
      "poi_short_description": "This 373 acre park offers a boat launch, fishing, trails, a dog park, a playground & picnic sites.",
      "poi_long_description": "People say this park offers a variety of activities, including biking, disc golf, fishing, and walking trails, and is a great place to see ducks and other waterfowl. They highlight the park's large size, beautiful natural scenery, and peaceful vibe, perfect for picnics and leisure walks. They also like the well-maintained trails and the availability of a dog park and covered picnic shelters.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ab-ce67-72a2-8cf7-b4ede87e8a26.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-ce67-72a2-8cf7-b4ede87e8a26",
        "storage_key": "property/6767906449166889/019d08ab-ce67-72a2-8cf7-b4ede87e8a26.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.eugene-or.gov/facilities/facility/details/Alton-Baker-Park-29",
      "poi_directions_map_url": "https://maps.google.com/?cid=10367398852171981920&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "alton-baker-park",
      "poi_latitude": "44.054978",
      "poi_longitude": "-123.0795561",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 541-682-4800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-0a1d-7583-8eea-3ac3035d4423.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-0a1d-7583-8eea-3ac3035d4423",
        "storage_key": "property/6767906449166889/019d08ac-0a1d-7583-8eea-3ac3035d4423.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-Xr6iiAewVQRYOSAxFNm4I8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_5f8f30c0-778a-4173-ba5c-c17ffc2cedd0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "custom",
      "poi_name": "Skinner Butte Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "248 Cheshire Ave, Eugene, OR 97401, USA",
      "poi_short_description": "Hilltop space featuring trails, climbing rocks, a playground & sweeping city & mountain views.",
      "poi_long_description": "Visitors say this park offers well-maintained trails, a playground with swings and a sandbox, and a rock climbing area. They also highlight the beautiful views of the city and river, and the abundance of parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ab-d4f4-7512-beab-00947c6ba5e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-d4f4-7512-beab-00947c6ba5e9",
        "storage_key": "property/6767906449166889/019d08ab-d4f4-7512-beab-00947c6ba5e9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.eugene-or.gov/Facilities/Facility/Details/Skinner-Butte-Park-55",
      "poi_directions_map_url": "https://maps.google.com/?cid=6418297527802315185&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "skinner-butte-park",
      "poi_latitude": "44.0591723",
      "poi_longitude": "-123.0926201",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 541-682-4800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-0a1d-7583-8eea-3ac3035d4423.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-0a1d-7583-8eea-3ac3035d4423",
        "storage_key": "property/6767906449166889/019d08ac-0a1d-7583-8eea-3ac3035d4423.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1UkJOwkewVQRscFsj5hfElk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_4714e1c8-0a81-473c-8584-d5a4e518ebee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "custom",
      "poi_name": "Hendricks Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Summit Ave &, Skyline Blvd, Eugene, OR 97403, USA",
      "poi_short_description": "Eugene's oldest city park, featuring hiking trails, picnic tables & 200-year-old Douglas fir trees.",
      "poi_long_description": "People say this park offers beautiful rhododendron gardens, lush green grass, and numerous walking paths through trees and other plants. They highlight the peaceful and tranquil vibe, and the well-maintained trails suitable for hiking, running, and leisurely strolls. They also like the availability of restrooms, picnic tables, and a spacious shelter for group gatherings. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ab-d6bf-7589-a0f0-3f7e82fdd640.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-d6bf-7589-a0f0-3f7e82fdd640",
        "storage_key": "property/6767906449166889/019d08ab-d6bf-7589-a0f0-3f7e82fdd640.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.eugene-or.gov/facilities/facility/details/80",
      "poi_directions_map_url": "https://maps.google.com/?cid=7945345221372150014&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hendricks-park",
      "poi_latitude": "44.0353374",
      "poi_longitude": "-123.0587689",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 541-682-4800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-0a1d-7583-8eea-3ac3035d4423.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-0a1d-7583-8eea-3ac3035d4423",
        "storage_key": "property/6767906449166889/019d08ac-0a1d-7583-8eea-3ac3035d4423.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJsbwIZ8wfwVQR_gC88WGJQ24",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_df852926-c5a7-4f13-a8df-fc5475404f6c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "custom",
      "poi_name": "Owen Rose Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "300 N Jefferson St, Eugene, OR 97402, USA",
      "poi_short_description": "Pretty park with floral displays, picnic areas, biking & pedestrian paths & a performance space.",
      "poi_long_description": "People say this community garden offers a wide variety of roses and flowers, as well as trails, benches, and a gazebo. They highlight the peaceful and healing atmosphere, perfect for picnics, photo shoots, and weddings, and the well-maintained grounds. They also like the convenient access to the river path and the availability of parking and restrooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ab-d6c5-74ce-a5aa-6498672db04a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-d6c5-74ce-a5aa-6498672db04a",
        "storage_key": "property/6767906449166889/019d08ab-d6c5-74ce-a5aa-6498672db04a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.eugene-or.gov/Facilities/Facility/Details/124",
      "poi_directions_map_url": "https://maps.google.com/?cid=8900275571844294163&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "owen-rose-garden",
      "poi_latitude": "44.0627779",
      "poi_longitude": "-123.1024347",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 541-682-4800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-0a1d-7583-8eea-3ac3035d4423.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-0a1d-7583-8eea-3ac3035d4423",
        "storage_key": "property/6767906449166889/019d08ac-0a1d-7583-8eea-3ac3035d4423.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2cDHBwoewVQRE6bdFnohhHs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "garden"
    },
    {
      "id": "custom_570a01b2-f2f8-41fb-96b7-702f57239838",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "custom",
      "poi_name": "Emerald Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1400 Lake Dr, Eugene, OR 97404, USA",
      "poi_short_description": "Large community park featuring an indoor pool and a gym alongside walking paths.",
      "poi_long_description": "Visitors say this park offers a skate park, playground, picnic areas, and a swimming pool, making it a great place for families with kids of all ages. They also highlight the spaciousness of the park, with plenty of room to play and relax, and the abundance of picnic tables and benches.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-8044-76a8-a2c9-18eed739fa16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-8044-76a8-a2c9-18eed739fa16",
        "storage_key": "property/6767906449166889/019d08ac-8044-76a8-a2c9-18eed739fa16.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.rrpark.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6424764170826829279&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "emerald-park",
      "poi_latitude": "44.0849492",
      "poi_longitude": "-123.1382173",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 541-688-4052",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-0a1d-7583-8eea-3ac3035d4423.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-0a1d-7583-8eea-3ac3035d4423",
        "storage_key": "property/6767906449166889/019d08ac-0a1d-7583-8eea-3ac3035d4423.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJs86dkJgdwVQR303KN_lYKVk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_9d348b77-73ea-4f6d-9bd7-cdd900742c31",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "custom",
      "poi_name": "Eugene Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "28801 Douglas Dr, Eugene, OR 97402, USA",
      "poi_short_description": "Small airport offering regional flights, plus an on-site art gallery & live music.",
      "poi_long_description": "Small airport offering regional flights, plus an on-site art gallery & live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ab-f0e7-7439-928e-7fc05f441e63.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-f0e7-7439-928e-7fc05f441e63",
        "storage_key": "property/6767906449166889/019d08ab-f0e7-7439-928e-7fc05f441e63.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.eugene-or.gov/173/Airport",
      "poi_directions_map_url": "https://maps.google.com/?cid=17774773147208674707&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "eugene-airport",
      "poi_latitude": "44.1217811",
      "poi_longitude": "-123.2159003",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 541-682-5544",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-116d-7467-a9e7-24fb133c9be2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-116d-7467-a9e7-24fb133c9be2",
        "storage_key": "property/6767906449166889/019d08ac-116d-7467-a9e7-24fb133c9be2.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0X3bxN4CwVQRk22GqgCurPY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_0a5a5432-bb9a-4cfc-ba14-ff0f06e24ca0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "custom",
      "poi_name": "Eugene, Oregon Amtrak Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "433 Willamette St, Eugene, OR 97401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-7fed-7423-9a19-4a664644979d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-7fed-7423-9a19-4a664644979d",
        "storage_key": "property/6767906449166889/019d08ac-7fed-7423-9a19-4a664644979d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=EUG",
      "poi_directions_map_url": "https://maps.google.com/?cid=9641760591181313434&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "eugene-oregon-amtrak-station",
      "poi_latitude": "44.0551854",
      "poi_longitude": "-123.0923267",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-9660-7035-ad2b-6682c5944ad4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-9660-7035-ad2b-6682c5944ad4",
        "storage_key": "property/6767906449166889/019d08ac-9660-7035-ad2b-6682c5944ad4.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJLcw7HBIewVQRmvW4ZixqzoU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_94d13149-6470-4d30-a43f-ed26fc86d8cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "custom",
      "poi_name": "Peacehealth Riverbend Annex",
      "poi_type": "Major Employers & Offices",
      "poi_address": "123 International Way, Springfield, OR 97477, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-80da-73fd-8896-1338c88bd2b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-80da-73fd-8896-1338c88bd2b9",
        "storage_key": "property/6767906449166889/019d08ac-80da-73fd-8896-1338c88bd2b9.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://www.peacehealth.org/locations/springfield",
      "poi_directions_map_url": "https://maps.google.com/?cid=7622165297999577075&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "peacehealth-riverbend-annex",
      "poi_latitude": "44.0870215",
      "poi_longitude": "-123.0305741",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 541-222-7300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-02af-7499-8603-4afd9cb8c9d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-02af-7499-8603-4afd9cb8c9d5",
        "storage_key": "property/6767906449166889/019d08ac-02af-7499-8603-4afd9cb8c9d5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMUrXZ0PjwFQR8_-SXvRex2k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_1d392c4d-94bb-4b78-97bf-980f272adef0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "custom",
      "poi_name": "Bi-Mart Corporate Distribution Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3400 W 1st Ave, Eugene, OR 97402, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-8379-72ea-9528-1ff2a6374bbd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-8379-72ea-9528-1ff2a6374bbd",
        "storage_key": "property/6767906449166889/019d08ac-8379-72ea-9528-1ff2a6374bbd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.bimart.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6160594235076786086&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bi-mart-corporate-distribution-center",
      "poi_latitude": "44.05795370000001",
      "poi_longitude": "-123.1482363",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 541-344-0681",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-02af-7499-8603-4afd9cb8c9d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-02af-7499-8603-4afd9cb8c9d5",
        "storage_key": "property/6767906449166889/019d08ac-02af-7499-8603-4afd9cb8c9d5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv1I_Pi4cwVQRpjcSC9HTflU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_65c4f1a7-e12d-48f4-97db-88c7bde9f781",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "custom",
      "poi_name": "Papé Group Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "355 Goodpasture Island Rd #300, Eugene, OR 97401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-887e-7768-81c8-893a36323527.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-887e-7768-81c8-893a36323527",
        "storage_key": "property/6767906449166889/019d08ac-887e-7768-81c8-893a36323527.webp",
        "width": 1280,
        "height": 727
      },
      "poi_business_url": "https://www.pape.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12304893125189133928&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pap-group-corporate-office",
      "poi_latitude": "44.0729893",
      "poi_longitude": "-123.1115279",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 541-683-5073",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-02af-7499-8603-4afd9cb8c9d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-02af-7499-8603-4afd9cb8c9d5",
        "storage_key": "property/6767906449166889/019d08ac-02af-7499-8603-4afd9cb8c9d5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpX7pqu8dwVQRaGYLbhrDw6o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_8b63fd44-272d-4175-9da2-73c22e182b2f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "custom",
      "poi_name": "Springfield City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "225 5th St, Springfield, OR 97477, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-87b5-70f9-ab3b-0f1a1b9d3fb6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-87b5-70f9-ab3b-0f1a1b9d3fb6",
        "storage_key": "property/6767906449166889/019d08ac-87b5-70f9-ab3b-0f1a1b9d3fb6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.springfield-or.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=413324433154469785&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "springfield-city-hall",
      "poi_latitude": "44.0473086",
      "poi_longitude": "-123.0192832",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 541-726-3700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-116b-724f-a358-c8a58aa7a270.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-116b-724f-a358-c8a58aa7a270",
        "storage_key": "property/6767906449166889/019d08ac-116b-724f-a358-c8a58aa7a270.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ62z1g0rgwFQRmW8pz2FsvAU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_2666bd2b-6929-4a75-b66c-0bc800978d5c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "custom",
      "poi_name": "Lane Community jail",
      "poi_type": "Major Employers & Offices",
      "poi_address": "101 W 5th Ave, Eugene, OR 97401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-885a-756b-ba51-63f00141f706.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-885a-756b-ba51-63f00141f706",
        "storage_key": "property/6767906449166889/019d08ac-885a-756b-ba51-63f00141f706.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://inmateinformation.lanecounty.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2483686843688901218&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lane-community-jail",
      "poi_latitude": "44.0549622",
      "poi_longitude": "-123.094692",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 541-682-4263",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d08ac-02af-7499-8603-4afd9cb8c9d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-02af-7499-8603-4afd9cb8c9d5",
        "storage_key": "property/6767906449166889/019d08ac-02af-7499-8603-4afd9cb8c9d5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjfF7eqgfwVQRYlpjcwbUdyI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_5c85d24b-b085-4b5f-9249-38d6d07df457",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_207f876b-a190-4aae-a87a-5651ba098869",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_8630af1f-8def-4120-b2ef-898563a9af52",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_f64ea0cb-a031-45fe-add3-974d8e118fd4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_3a66212b-a584-4ebb-830c-5a66b2cad5a9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_6b423426-ecae-4cf6-a2d6-d555e7e8df33",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "day": "SAT",
      "open_time": "09:00",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "custom_3cb5c63b-ebed-4047-bd7a-f937615fd66e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "rating": "5.0",
      "name": "Kate Sigman",
      "text": "We lived at Creekside Village for almost 3 years and loved it! The staff are responsive and helpful and the amenities are great. We never had any issues with our neighbors or with car break ins.  They even have a security company that drives around to check on things and you can report issues to them if you see something suspicious. There is TONS of extra parking and the mail/garbage locations are spread out in a way that makes them accessible.  Our apartment had been recently redone with new carpet and appliances.\nLike most housing in Eugene, we wished it was a little cheaper but for the neighborhood and the way they kept up the property grounds, we felt like it was fair.  Upon move out, we found their assessment of our apartment fair and we didn’t have to fight them like you normally have to with landlords, which we appreciated!",
      "date": "2025-09-18",
      "title": ""
    },
    {
      "id": "custom_ba8c11a6-3da3-41c7-b4ca-4b0a514d32bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "rating": "5.0",
      "name": "Melly S",
      "text": "My husband and I lived there for 3 years. We loved living there and the pretty walk and bike path behind the apartment, but it's time to move on to a bigger space.\nDuring our stay, office management have always been responsive and respectful. One time our fridge broke down on a Sunday, and only one maintenance guy worked. We were able to get a replacement fridge the same day. Another maintenance guy (Chris) was on his day off that day, and he was able to help the other guy lift the fridge to our apartment on the 3rd floor that day! We really appreciate this. Another time, our toilet broke, maintenance was able to come in within that same hour!\nThis place honestly (in my experience) have one of the most responsive office management and maintenance folks.\nOur walk out inspection was also smooth.\nThank you for everything! This little apartment was very memorable for us.",
      "date": "2025-06-01",
      "title": ""
    },
    {
      "id": "custom_0ec831f2-4e34-422f-b6da-bfb50a4be4cc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "rating": "5.0",
      "name": "B J R",
      "text": "I just wanted to say that the 2 maintenance people who have helped us so far during our short time here have been excellent! Both men were professional, courteous, on time, and got our issues fixed. Creekside Village has the most professional maintenance people I've ever experienced in any apartment complex. Thank you!",
      "date": "2024-10-29",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_6f28ed30-e92d-4582-ae70-33e8ffdc9a73",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d2b49-6efc-77df-b65d-a197b4227d0b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2b49-6efc-77df-b65d-a197b4227d0b",
        "storage_key": "property/6767906449166889/019d2b49-6efc-77df-b65d-a197b4227d0b.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Creekside Village Apartments - 2 Bedroom 1 Bath 896 Sq. Ft. Model Apartment",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=cgo2vMQ8RHR"
    },
    {
      "id": "custom_c01e5e40-5131-4239-b8b7-58e7dfd69b9c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d2b49-8dd3-77b2-8a27-6899fabd0bf7.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2b49-8dd3-77b2-8a27-6899fabd0bf7",
        "storage_key": "property/6767906449166889/019d2b49-8dd3-77b2-8a27-6899fabd0bf7.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Creekside Village Apartments - Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=z7ozDsLm6dC"
    },
    {
      "id": "custom_351bbb7a-b01a-41e1-907c-ebf5e8e7526c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d2b49-b301-7253-982c-51201884bdbb.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2b49-b301-7253-982c-51201884bdbb",
        "storage_key": "property/6767906449166889/019d2b49-b301-7253-982c-51201884bdbb.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Creekside Village Apartments - Indoor Spa",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=SwzGDuZM7Hb"
    },
    {
      "id": "custom_04767c31-7958-45b9-9e87-62779b48d72e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d2b49-cb57-735c-8451-affbf884465b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2b49-cb57-735c-8451-affbf884465b",
        "storage_key": "property/6767906449166889/019d2b49-cb57-735c-8451-affbf884465b.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Creekside Village Apartments - Pool",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=7He4hNwMYx1"
    },
    {
      "id": "custom_1b2e0dd1-8ef6-46bd-9070-4b003d344711",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166889/019d2b49-eb20-775b-add6-05c3aa25b9d7.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2b49-eb20-775b-add6-05c3aa25b9d7",
        "storage_key": "property/6767906449166889/019d2b49-eb20-775b-add6-05c3aa25b9d7.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Creekside Village Apartments - Clubhouse",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=jXmv6AwJMRR"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019db1a3-1577-70dc-b554-30d5e4716ba1",
      "lead_source": "LANDING_PAGE",
      "name": "Creekside Village Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "generator",
      "page_item_url": "pool-apartments-eugene-or-creekside-village",
      "search_query": "pool apartments in Eugene OR",
      "category": "Amenity",
      "h1_title": "Pool Apartments in Eugene, OR",
      "h2_subtitle": "Discover poolside living at Creekside Village. Luxurious pool apartments in Eugene, OR offer a refreshing lifestyle with top amenities.",
      "page_copy": "Welcome to Creekside Village, where luxury meets leisure at our pool apartments in Eugene, OR. Nestled in the peaceful Cal Young neighborhood, our community offers residents access to a stunning pool, perfect for relaxation or fun with friends. Enjoy a swim after work or spend sunny weekends lounging by the water, all while enjoying the peaceful surroundings and scenic views of Lane County.\n\nIn addition to our sparkling pool, Creekside Village provides a playground, a convenient dog park for your furry friends, and high-speed internet access. With easy access to online services, our residents experience comfort and modern convenience. Join us at Creekside Village and experience the ultimate in poolside living, right here in Eugene, OR. Your refreshing new lifestyle awaits!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pool Apartments in Eugene, OR | Creekside Village",
      "seo_description": "Discover pool apartments in Eugene, OR at Creekside Village. Enjoy luxury living with top amenities and a stunning pool. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "generator",
      "page_item_url": "dog-park-apartments-cal-young-creekside-village",
      "search_query": "dog park apartments Cal Young",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments in Cal Young",
      "h2_subtitle": "Live in pet-friendly luxury at Creekside Village. Our dog park apartments in Cal Young offer the ideal environment for you and your furry friends.",
      "page_copy": "Welcome to Creekside Village, the ideal choice for those seeking dog park apartments in Cal Young. Located in the heart of Eugene, OR, our community caters to pet lovers and their furry companions with our dedicated dog park. It's the perfect place for your pets to play, socialize, and exercise right within the safety of the community.\n\nBeyond the dog park, Creekside Village apartments offer a range of amenities designed for comfort and convenience. Our residents enjoy a playground, a relaxing pool, and high-speed internet access, ensuring you stay connected. Nestled in Lane County's charming neighborhood, our pet-friendly apartments promise a welcoming community atmosphere. Experience the best of Cal Young living at Creekside Village today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments in Cal Young | Creekside Village",
      "seo_description": "Find dog park apartments in Cal Young at Creekside Village. Enjoy pet-friendly living with great amenities in Eugene, OR. Visit us and explore today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "generator",
      "page_item_url": "apartments-with-in-unit-washer-dryer-lane-county-creekside-village",
      "search_query": "apartments with in-unit washer dryer Lane County",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Washer Dryer",
      "h2_subtitle": "Enjoy ultimate convenience at Creekside Village. Our Lane County apartments feature in-unit washer and dryer for hassle-free living.",
      "page_copy": "Creekside Village brings you the perfect blend of comfort and convenience with our apartments featuring in-unit washer and dryer facilities in Lane County. Located in the serene Cal Young neighborhood of Eugene, OR, our community enhances your lifestyle, making laundry days effortless and stress-free. Enjoy the privacy and efficiency of having laundry facilities right in the comfort of your own home.\n\nIn addition to this convenient feature, Creekside Village offers a wide array of amenities including a sparkling pool, a dedicated dog park, and high-speed internet access. Our modern, pet-friendly community is designed to make life easier and more enjoyable. Experience the ultimate convenience and unmatched comfort at Creekside Village in Lane County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Washer Dryer | Lane County",
      "seo_description": "Discover apartments with in-unit washer dryer in Lane County at Creekside Village. Enjoy the convenience of hassle-free living in Eugene, OR.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "generator",
      "page_item_url": "high-speed-internet-apartments-97401-creekside-village",
      "search_query": "high speed internet access apartments 97401",
      "category": "Amenity",
      "h1_title": "High Speed Internet Apartments 97401",
      "h2_subtitle": "Stay connected at Creekside Village. Our apartments in the 97401 area offer high speed internet access for seamless online experiences.",
      "page_copy": "Discover Creekside Village, where connectivity meets comfort in our high speed internet access apartments in the 97401 area. Perfectly situated in Eugene's thriving Cal Young neighborhood, our community ensures you stay connected with seamless, fast internet throughout your daily activities. Whether you work from home, stream entertainment, or game online, our apartments cater to your digital needs.\n\nApart from high speed internet access, Creekside Village features amenities that elevate your living experience, including a refreshing pool, a welcoming dog park, and a playground for younger residents. Nestled in the heart of Lane County, our apartments are designed to provide convenience, comfort, and a vibrant community atmosphere. Embrace modern living with all the essential amenities at your fingertips at Creekside Village.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "High Speed Internet Access Apartments | 97401",
      "seo_description": "Find high speed internet access apartments in 97401 at Creekside Village. Enjoy seamless connection and great amenities in Eugene, OR.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-near-goodpasture-loop-creekside-village",
      "search_query": "fitness center apartments near Goodpasture Loop",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments Near Goodpasture Loop",
      "h2_subtitle": "Achieve your fitness goals at Creekside Village. Our apartments near Goodpasture Loop offer a fully-equipped fitness center and more.",
      "page_copy": "At Creekside Village, not only do you get a home, but a lifestyle that supports your fitness journey. Our fitness center apartments near Goodpasture Loop provide a fully-equipped on-site gym, allowing you to work out at your convenience without leaving the comfort of your community. Located in the vibrant Cal Young neighborhood of Eugene, OR, we offer a perfect blend of activity and relaxation.\n\nIn addition to the top-notch fitness center, Creekside Village boasts a variety of amenities including a sparkling pool, a spacious dog park, and quick access to high speed internet. Nestled in Lane County, our apartments ensure you have everything needed for a healthy, balanced lifestyle. Experience the synergy of wellness and modern living at Creekside Village.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments Near Goodpasture Loop",
      "seo_description": "Explore fitness center apartments near Goodpasture Loop at Creekside Village. Enjoy convenient workouts and great amenities in Eugene, OR.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-eugene-or-creekside-village",
      "search_query": "one bedroom apartments eugene or",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Eugene, OR",
      "h2_subtitle": "Discover comfort at Creekside Village. Our one bedroom apartments in Eugene, OR offer modern amenities and a prime location.",
      "page_copy": "Creekside Village is proud to offer spacious one bedroom apartments in Eugene, OR, designed with your comfort and convenience in mind. Located in the beautiful Cal Young neighborhood, our community provides a serene setting while offering easy access to Eugene's vibrant city life.\n\nOur one-bedroom units are perfect for individuals or couples looking for a modern home with amenities such as high-speed internet, a tranquil outdoor pool, and a pet-friendly dog park. Enjoy the perfect balance of quiet residential living and city convenience at Creekside Village. Embrace a lifestyle of comfort and connectivity in the heart of Lane County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments | Eugene, OR",
      "seo_description": "Find stunning one bedroom apartments in Eugene, OR at Creekside Village. Enjoy modern amenities and a vibrant lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-near-cal-young-creekside-village",
      "search_query": "two bedroom apartments near cal young",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near Cal Young",
      "h2_subtitle": "Explore luxury living at Creekside Village. Our two bedroom apartments near Cal Young provide spacious comfort and top amenities.",
      "page_copy": "Located in the desirable Cal Young neighborhood, Creekside Village offers spacious two-bedroom apartments that perfectly blend comfort and convenience. Ideal for families or roommates, our units provide ample living space complemented by modern amenities. Nestled in Eugene, OR, our community is the epitome of suburban tranquility while granting easy access to the vibrant downtown scene.\n\nResidents can enjoy a multitude of facilities including a well-maintained playground, refreshing pool, and a dog-friendly park. High-speed internet access ensures you're connected at all times, whether for work or leisure. Experience the essence of contemporary living at Creekside Village, where your new two-bedroom home awaits.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near Cal Young",
      "seo_description": "Discover spacious two bedroom apartments near Cal Young at Creekside Village. Enjoy luxury living with top amenities in Eugene, OR.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166889",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-lane-county-creekside-village",
      "search_query": "three bedroom apartments lane county",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Lane County",
      "h2_subtitle": "Welcome to spacious living at Creekside Village. Our three bedroom apartments in Lane County are perfect for growing families and expansive living.",
      "page_copy": "Creekside Village offers the perfect solution for those seeking three bedroom apartments in Lane County. Our spacious units are designed to accommodate families and individuals who value comfort and flexibility. Situated in the charming neighborhood of Cal Young in Eugene, OR, our community embodies a peaceful residential ambiance coupled with modern conveniences.\n\nEach three-bedroom apartment features ample living space and access to exceptional amenities, such as a refreshing pool, a dog park, and a children's playground. With high-speed internet available, staying connected and productive from home is effortlessly simple. Discover the advantages of living in a community that prioritizes both luxury and practicality at Creekside Village.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Lane County",
      "seo_description": "Explore spacious three bedroom apartments in Lane County at Creekside Village. Enjoy abundant amenities and comfort in Eugene, OR.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5619"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18372404238"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "\tGTM-MWLFFDN9"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "40343719840"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-601-4065 "
    }
  ],
  "custom_qb_id": "5619",
  "custom_repli_id": "18372404238",
  "custom_google_gtm_id": "\tGTM-MWLFFDN9",
  "custom_hubspot_company_id": "40343719840",
  "custom_ppc_tracking_phone_number": "844-601-4065 "
};

export const generatedAt = '2026-09-23T19:56:39.206Z';
